var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function (cents, format) {
  if (typeof cents == "string") {
    cents = cents.replace(".", "");
  }
  var value = "";
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || this.money_format;

  function defaultOption(opt, def) {
    return typeof opt == "undefined" ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split("."),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
      cents = parts[1] ? decimal + parts[1] : "";

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
  }

  return formatString.replace(placeholderRegex, value);
};


// REVEAL ON SCROLL
class ScrollReveal {
  constructor(selector = ".reveal", staggerDelay = 300) {
    this.selector = selector;
    this.staggerDelay = staggerDelay;

    this.isEditor = Shopify && Shopify.designMode;

    this.observer = new IntersectionObserver(this.onIntersect.bind(this), {
      root: null,
      threshold: 0.2,
    });

    this.initElements();
  }

  initElements(scope = document) {
    const elements = scope.querySelectorAll(this.selector);

    elements.forEach((el) => {
      if (el.dataset.revealed === "true") return;

      //  FIX: show instantly in editor
      if (this.isEditor) {
        el.style.opacity = 1;
        el.style.transform = "none";
        el.dataset.revealed = "true";
        return;
      }

      el.style.opacity = 0;
      el.style.transform = "translateY(20px)";
      el.style.transition = "opacity 0.4s ease, transform 0.4s ease";

      this.observer.observe(el);
    });
  }

  // Stagger reveal for a specific batch
  staggerBatch(elements) {
    elements.forEach((el, index) => {
      setTimeout(() => {
        el.style.opacity = 1;
        el.style.transform = "translateY(0)";
        el.dataset.revealed = "true";
      }, index * this.staggerDelay);

      this.observer.unobserve(el);
    });
  }

  onIntersect(entries, observer) {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;

      const el = entry.target;

      // normal scroll-based stagger (initial load)
      if (el.classList.contains("stagger")) {
        const siblings = Array.from(
          el.parentNode.querySelectorAll(".reveal.stagger"),
        ).filter((sib) => sib.dataset.revealed !== "true");

        this.staggerBatch(siblings);
      } else {
        el.style.opacity = 1;
        el.style.transform = "translateY(0)";
        el.dataset.revealed = "true";
        observer.unobserve(el);
      }
    });
  }
}

// Initialize on DOM ready
let scrollReveal;

document.addEventListener("DOMContentLoaded", () => {
  scrollReveal = new ScrollReveal(".reveal", 150);
});

document.addEventListener("shopify:section:load", (event) => {
  if (!scrollReveal) return;
  scrollReveal.initElements(event.target);
});


// DEBOUNCE
function debounce(fn, delay) {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => fn.apply(this, args), delay);
  };
}


// SWIPER
function numAttr(value, fallback) {
  if (value === undefined || value === null || value === "") return fallback;
  const parsed = Number(value);
  return Number.isNaN(parsed) ? fallback : parsed;
}

// Product-card swiper slides
function equalizeProductCardHeights(swiperEl) {
  if (!swiperEl) return;
  const cards = swiperEl.querySelectorAll(".product_card_wrapper");
  if (!cards.length) return;

  cards.forEach((card) => {
    card.style.removeProperty("min-height");
  });

  let tallest = 0;
  cards.forEach((card) => {
    tallest = Math.max(tallest, card.getBoundingClientRect().height);
  });

  cards.forEach((card) => {
    card.style.minHeight = `${tallest}px`;
  });
}

class SwiperSection extends HTMLElement {
  connectedCallback() {
    this.swiperEl = this.querySelector(".swiper");
    if (!this.swiperEl) return;

    this.waitForSwiper().then(() => this.init());
  }

  waitForSwiper() {
    return new Promise((resolve) => {
      const check = () => {
        if (window.Swiper) return resolve();
        requestAnimationFrame(check);
      };
      check();
    });
  }

  init() {
    if (this.swiper) return;

    /* ---------- read dataset ---------- */
    this.slidesDesktop = Number(this.dataset.slidesDesktop) || 1;
    this.slidesTablet = Number(this.dataset.slidesTablet) || 3;
    this.slidesMobile = Number(this.dataset.slidesMobile) || 1;
    this.slidesCustom = Number(this.dataset.slidesCustom) || 2;

    this.speed = Number(this.dataset.speed) || 600;
    this.loop = this.dataset.loop === "true";
    this.freeMode = this.dataset.freeMode === "true";
    this.effect = this.dataset.effect || "slide";
    this.gap = numAttr(this.dataset.gap, 15);
    this.customGap = numAttr(this.dataset.customGap, this.gap);
    this.mobileGap = numAttr(this.dataset.mobileGap, 15);
    this.centerMode = this.dataset.centerMode === "true";

    /* thumbnail slider Vertical and left and right  */
    this.direction = this.dataset.direction === "vertical" ? "vertical" : "horizontal";
    /* thumbnail slider Vertical and left and right  */

    this.observeParents = this.dataset.observeParents === "true";
    this.autoHeight = this.dataset.autoHeight === "true";
    this.grabCursor = this.dataset.grabCursor === "true";
    this.watchSlidesProgress = this.dataset.progress === "true";
    this.allowTouchMove = this.dataset.allowTouchMove !== "false";

    this.paginationEl = this.querySelector(".swiper-pagination");
    this.paginationType = this.dataset.paginationType || "bullets";
    this.paginationSeek = this.dataset.paginationSeek !== "false";

    /* Opt-out for sliders that own their own ARIA, e.g. a thumbnail tablist */
    this.a11yEnabled = this.dataset.a11y !== "false";
    this.slideRole = this.dataset.slideRole || "";

    this.autoplayEnabled =
      this.dataset.autoplay === "true" || this.dataset.autoplay === "1";
    this.delay = Number(this.dataset.delay) || 3000;

    this.thumbsSelector = this.dataset.thumbs;

    /* ---------- thumbs handling ---------- */
    if (this.thumbsSelector) {
      this.resolveThumbs().then((thumbsSwiper) => this.createSwiper(thumbsSwiper));
      return;
    }

    /* ---------- no thumbs ---------- */
    this.createSwiper();
  }

  /* The thumbs rail renders after the main slider, so wait for it to exist */
  resolveThumbs() {
    const scope = this.closest("[data-section-id]") || document;
    const deadline = performance.now() + 5000;

    return new Promise((resolve) => {
      const check = () => {
        if (!this.isConnected) return resolve(null);

        const thumbsEl = scope.querySelector(`.${this.thumbsSelector}`);
        if (thumbsEl?.swiperInstance) return resolve(thumbsEl.swiperInstance);

        /* Bounded so a missing rail cannot leave a frame loop running forever */
        if (performance.now() > deadline) return resolve(null);

        requestAnimationFrame(check);
      };
      check();
    });
  }

  animateActiveSlide(swiper) {
    const activeSlide = swiper.slides[swiper.activeIndex];
    if (!activeSlide) return;

    // content animation
    const content = activeSlide.querySelector(".slideshow_slide_content_inner");

    if (content && this.contains(content)) {
      setTimeout(() => {
        content.classList.add("animate-in");
      }, 100);
    }
  }

  createSwiper(thumbsSwiper = null) {
    if (this.swiper) return;

    this.swiper = new Swiper(this.swiperEl, {
      slidesPerView: this.slidesMobile,
      /* thumbnail slider Vertical and left and right  */
      direction: this.direction,
      /* thumbnail slider Vertical and left and right  */
      spaceBetween: this.gap,
      speed: this.speed,
      loop: this.loop,
      freeMode: this.freeMode,
      centeredSlides: this.centerMode,
      grabCursor: this.grabCursor,
      effect: this.effect,
      // touchStartPreventDefault: false,

      observeParents: this.observeParents,
      autoHeight: this.autoHeight,
      grabCursor: this.grabCursor,
      watchSlidesProgress: this.watchSlidesProgress,
      allowTouchMove: this.allowTouchMove,
      a11y: {
        enabled: this.a11yEnabled,
        ...(this.slideRole && { slideRole: this.slideRole }),
      },

      breakpoints: {
        0: {
          slidesPerView: this.slidesMobile,
          spaceBetween: this.mobileGap,
          freeMode: false,
        },
        640: { slidesPerView: this.slidesCustom, spaceBetween: this.customGap },
        899: { slidesPerView: this.slidesTablet, spaceBetween: this.customGap },
        1199: { slidesPerView: this.slidesDesktop },
      },

      ...(this.autoplayEnabled && {
        autoplay: {
          delay: this.delay,
          disableOnInteraction: false,
        },
      }),

      ...(this.paginationEl && {
        pagination: {
          el: this.paginationEl,
          clickable: true,
          type: this.paginationType,
          renderBullet: function (index, className) {
            return `
              <span class="${className}">
               -
              </span>
            `;
          },
        },
      }),

      on: {
        slideChangeTransitionStart: (swiper) => {
          this.querySelectorAll(".slideshow_slide_content_inner").forEach((el) => {
            el.classList.remove("animate-in");
          });

          this.querySelectorAll(".progress-ring__progress").forEach((circle) => {
            circle.style.animation = "none";
            circle.getBoundingClientRect();
            circle.style.animation = "";
          });
        },
        init: (swiper) => {
          this.animateActiveSlide(swiper);
          equalizeProductCardHeights(this.swiperEl);
          window.dispatchEvent(new Event("layout:updated"));
        },
        slideChangeTransitionEnd: (swiper) => {
          this.animateActiveSlide(swiper);
        },
        resize: () => {
          equalizeProductCardHeights(this.swiperEl);
          window.dispatchEvent(new Event("layout:updated"));
        },
      },

      ...(thumbsSwiper && {
        thumbs: {
          swiper: thumbsSwiper,
        },
      }),

      navigation: {
        nextEl: this.querySelector(".swiper-button-next"),
        prevEl: this.querySelector(".swiper-button-prev"),
      }
    });

    /* expose instance for thumbs linking */
    this.swiperEl.swiperInstance = this.swiper;

    this.swiperEl.style.setProperty(
      "--swiper-autoplay-duration",
      `${this.delay}ms`,
    );

    if (this.paginationEl && this.paginationType === "progressbar" && this.paginationSeek) {
      this.bindProgressbarSeek();
    }
  }

  /* progressbar pagination is a display-only bar by default*/
  bindProgressbarSeek() {
    const el = this.paginationEl;

    /* thumbnail slider Vertical and left and right  */
    const seekTo = (event) => {
      const rect = el.getBoundingClientRect();
      const isVertical = this.direction === "vertical";
      const size = isVertical ? rect.height : rect.width;
      if (!size) return;

      const offset = isVertical ? event.clientY - rect.top : event.clientX - rect.left;
      const clamped = Math.min(Math.max(offset / size, 0), 1);
      const realSlides = this.swiperEl.querySelectorAll(
        ".swiper-slide:not(.swiper-slide-duplicate)",
      ).length;
      if (realSlides < 2) return;

      const targetIndex = Math.round(clamped * (realSlides - 1));

      if (this.loop) {
        this.swiper.slideToLoop(targetIndex);
      } else {
        this.swiper.slideTo(targetIndex);
      }
    };

    let pointerId = null;

    el.addEventListener("pointerdown", (event) => {
      if (!event.isPrimary) return;
      pointerId = event.pointerId;
      if (el.setPointerCapture) el.setPointerCapture(pointerId);
      seekTo(event);
      event.preventDefault();
    });

    el.addEventListener("pointermove", (event) => {
      if (pointerId === null || event.pointerId !== pointerId) return;
      seekTo(event);
    });

    const endDrag = (event) => {
      if (pointerId === null || event.pointerId !== pointerId) return;
      if (el.releasePointerCapture && el.hasPointerCapture(pointerId)) {
        el.releasePointerCapture(pointerId);
      }
      pointerId = null;
    };

    el.addEventListener("pointerup", endDrag);
    el.addEventListener("pointercancel", endDrag);
    /* thumbnail slider Vertical and left and right end */
  }

  disconnectedCallback() {
    if (!this.swiper) return;
    this.swiper.destroy(true, true);
    this.swiper = null;
  }
}

customElements.define("swiper-section", SwiperSection);


// NEWSLETTER FORM SUBMISSION
class SubmissionForm extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.form = this.querySelector('form');
    if (!this.form) return;

    this.button = this.form.querySelector('button[type="submit"]');
    this.email = this.form.querySelector('input[type="email"]');
    this.errorWrapper = this.form.querySelector('.manual_form_error_msg');

    if (!this.button || !this.email) return;

    this.button.addEventListener('click', (e) => {
      e.preventDefault();

      if (this.isValidEmail(this.email.value)) {
        this.errorWrapper?.classList.add('hidden');
        this.form.submit();
      } else {
        this.errorWrapper?.classList.remove('hidden');
      }
    });
  }

  isValidEmail(email) {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  }
}

customElements.define('submission-form', SubmissionForm);


// READ MORE / READ LESS
class ReadMore extends HTMLElement {
  constructor() {
    super();
    this.btn = this.querySelector('button');
  }

  connectedCallback() {
    if (!this.btn) return;
    this.rm = this.btn.querySelector('.read_more_btn');
    this.rl = this.btn.querySelector('.read_less_btn');
    this.btn.addEventListener('click', this.handleClick.bind(this));
    this.wrapper = this.previousElementSibling;
  }

  handleClick() {
    if (this.rm.classList.contains('active')) {
      this.rm.classList.remove('active');
      this.rl.classList.add('active');
      if (!this.wrapper) return;
      this.wrapper.classList.add('full');
    } else {
      this.rm.classList.add('active');
      this.rl.classList.remove('active');
      this.wrapper.classList.remove('full');
    }
  }
}

customElements.define('read-more', ReadMore);


// DISCOUNT CODE
class DiscountCode extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener('click', () => this.copyCode());
  }

  copyCode() {
    const textEl = this.querySelector('.dc');
    if (!textEl) return;

    const text = textEl.textContent.trim();

    navigator.clipboard.writeText(text).then(() => {
      this.classList.add('copied');

      // optional: remove after 2s
      setTimeout(() => {
        this.classList.remove('copied');
      }, 2000);
    }).catch(err => {
      console.error('Copy failed', err);
    });
  }
}

customElements.define('discount-code', DiscountCode);


// LOCALIZATION
class LocalizationWrapper extends HTMLElement {
  constructor() {
    super();

    this.currencyForm = this.querySelector("#currency_selector_form");
    this.languageForm = this.querySelector("#language_selector_form");

    this.currencyDropdown = this.querySelector('.currency_dropdown');
    this.languageDropdown = this.querySelector('.language_dropdown');

    this.activeButton = null;
    this.activeDropdown = null;

    this.handleClick = this.handleClick.bind(this);
    this.handleOutsideClick = this.handleOutsideClick.bind(this);
    this.handleKeydown = this.handleKeydown.bind(this);
  }

  connectedCallback() {
    this.addEventListener("click", this.handleClick);
    document.addEventListener("click", this.handleOutsideClick);
    document.addEventListener("keydown", this.handleKeydown);
  }

  disconnectedCallback() {
    this.removeEventListener("click", this.handleClick);
    document.removeEventListener("click", this.handleOutsideClick);
    document.removeEventListener("keydown", this.handleKeydown);
  }

  handleClick(e) {
    const currencyBtn = e.target.closest('.currency_selector_btn');
    const languageBtn = e.target.closest('.language_selector_btn');

    // Toggle dropdowns
    if (currencyBtn) {
      this.toggleDropdown(this.currencyDropdown, currencyBtn);
      return;
    }

    if (languageBtn) {
      this.toggleDropdown(this.languageDropdown, languageBtn);
      return;
    }

    // Handle selection
    const option = e.target.closest("button[data-value]");
    if (!option) return;

    if (option.closest(".currency_list")) {
      this.submitForm(this.currencyForm, "country_code", option.dataset.value);
    }

    if (option.closest(".language_list")) {
      this.submitForm(this.languageForm, "language_code", option.dataset.value);
    }

  }

  toggleDropdown(openEl, triggerBtn) {
    if (!openEl) return;

    const isOpen = openEl.classList.contains('active');

    this.closeAll();

    if (!isOpen) {
      openEl.classList.add('active');
      openEl.removeAttribute('inert');
      openEl.setAttribute('aria-hidden', 'false');
      this.activeDropdown = openEl;
      this.activeButton = triggerBtn;

      // Focus first button in dropdown
      setTimeout(() => {
        const firstBtn = openEl.querySelector("button[data-value]");
        if (firstBtn) firstBtn.focus();
      }, 0);
    }
  }

  submitForm(form, inputName, value) {
    if (!form) return;

    const input = form.querySelector(`input[name="${inputName}"]`);
    if (!input) return;

    input.value = value;
    form.submit();
  }

  handleOutsideClick(e) {
    if (!this.contains(e.target)) {
      this.closeAll();
    }
  }

  handleKeydown(e) {
    const isDropdownOpen = this.activeDropdown && this.activeDropdown.classList.contains('active');

    if (e.key === "Escape" && isDropdownOpen) {
      e.preventDefault();
      const btnToFocus = this.activeButton;
      this.closeAll();

      if (btnToFocus) {
        btnToFocus.focus();
      }
      return;
    }

    if (e.key === "Tab" && isDropdownOpen) {
      const focusableElements = this.activeDropdown.querySelectorAll("button[data-value]");
      if (focusableElements.length === 0) return;

      const firstElement = focusableElements[0];
      const lastElement = focusableElements[focusableElements.length - 1];
      const activeElement = document.activeElement;

      if (e.shiftKey) {
        // Shift + Tab on first element, focus last
        if (activeElement === firstElement) {
          e.preventDefault();
          lastElement.focus();
        }
      } else {
        // Tab on last element, focus first
        if (activeElement === lastElement) {
          e.preventDefault();
          firstElement.focus();
        }
      }
    }
  }

  closeAll() {
    [this.currencyDropdown, this.languageDropdown].forEach(el => {
      if (!el) return;
      el.classList.remove('active');
      el.setAttribute('inert', '');
      el.setAttribute('aria-hidden', 'true');
    });
    this.activeButton = null;
    this.activeDropdown = null;
  }
}

customElements.define("localization-wrapper", LocalizationWrapper);


// DRAWERS
const drawerOpenBtns = document.querySelectorAll(".drawer_open_btn");
const drawerCloseBtns = document.querySelectorAll(".drawer_close_btn");
const drawers = document.querySelectorAll(".drawer_wrapper");
let scrollPosition = 0;

let lastFocusedButton = null;

const DRAWER_FOCUSABLE_SELECTOR =
  "button, [href], input:not([type='hidden']), select, textarea, [tabindex]:not([tabindex='-1'])";

function getDrawerFocusable(drawer) {
  return Array.from(drawer.querySelectorAll(DRAWER_FOCUSABLE_SELECTOR)).filter(
    (el) =>
      !el.disabled &&
      !el.hasAttribute("inert") &&
      el.getAttribute("aria-hidden") !== "true" &&
      el.offsetWidth + el.offsetHeight > 0,
  );
}

function closeAllDrawers() {
  drawers.forEach((drawer) => {
    drawer.classList.remove("active");
    drawer.setAttribute("aria-hidden", "true");
    drawer.setAttribute("inert", "");
  });
}

function trapFocus(event, drawer) {
  if (event.key !== "Tab") return;

  const focusableElements = getDrawerFocusable(drawer);

  if (!focusableElements.length) {
    event.preventDefault();
    return;
  }

  const firstElement = focusableElements[0];
  const lastElement = focusableElements[focusableElements.length - 1];

  if (!drawer.contains(document.activeElement)) {
    event.preventDefault();
    firstElement.focus();
    return;
  }

  if (event.shiftKey && document.activeElement === firstElement) {
    event.preventDefault();
    lastElement.focus();
  } else if (!event.shiftKey && document.activeElement === lastElement) {
    event.preventDefault();
    firstElement.focus();
  }
}

function openDrawer(drawer, button, section) {
  closeAllDrawers();
  if (drawer) {
    if (!lastFocusedButton && button) {
      lastFocusedButton = button;
    }

    drawer.classList.add("active");
    drawer.removeAttribute("inert");
    drawer.setAttribute("aria-hidden", "false");

    const focusableElements = getDrawerFocusable(drawer);

    if (focusableElements.length) {
      focusableElements[0].focus();
    }

  }
}

function getActiveDrawer() {
  const activeDrawers = document.querySelectorAll(".drawer_wrapper.active");
  return activeDrawers.length ? activeDrawers[activeDrawers.length - 1] : null;
}

document.addEventListener("keydown", (event) => {
  if (event.key !== "Tab") return;

  const activeDrawer = getActiveDrawer();
  if (!activeDrawer) return;

  trapFocus(event, activeDrawer);
});

document.addEventListener("focusin", (event) => {
  const activeDrawer = getActiveDrawer();
  if (!activeDrawer) return;
  if (activeDrawer.contains(event.target)) return;
  if (event.target.closest(".glightbox-container, .gcontainer, dialog[open]")) return;

  const focusableElements = getDrawerFocusable(activeDrawer);
  if (focusableElements.length) focusableElements[0].focus();
});

function closeDrawer(drawer, section) {
  if (drawer) {
    drawer.classList.remove("active");
    drawer.setAttribute("inert", "");
    drawer.setAttribute("aria-hidden", "true");

    const anyDrawerOpen = document.querySelector(".drawer_wrapper.active");

    if (!anyDrawerOpen && lastFocusedButton) {
      lastFocusedButton.focus();
      lastFocusedButton = null;
    }
  }
}

function AddScrollLock() {
  document.body.setAttribute("scroll-lock", "");
  document.body.classList.add("overflow-hidden");
  if (typeof lenis !== "undefined" && lenis?.stop) {
    lenis.stop();
  }
}

function RemoveScrollLock() {
  document.body.removeAttribute("scroll-lock");
  document.body.classList.remove("overflow-hidden");
  if (typeof lenis !== "undefined" && lenis?.start) {
    lenis.start();
  }
}

function initDrawerOpenButtons() {
  const openBtns = document.querySelectorAll("[data-drawer]");

  openBtns.forEach((button) => {
    if (!button.hasAttribute("data-drawer-initialized")) {
      button.setAttribute("data-drawer-initialized", "true");

      button.addEventListener("click", async (event) => {
        event.preventDefault();
        const drawerId = button.getAttribute("data-drawer");
        const drawer = document.getElementById(drawerId);
        // const rootSection = drawer.dataset.rootSection === "true";
        // const section = document.querySelector(".main-product-section");

        if (drawer) {
          // if (rootSection && section) {
          //   openDrawer(drawer, button, section);
          //   AddScrollLock();
          // } else {
          //   openDrawer(drawer, button);
          //   AddScrollLock();
          // }
          openDrawer(drawer, button);
          AddScrollLock();
        }
      });
    }
  });
}

document.addEventListener("DOMContentLoaded", initDrawerOpenButtons);
document.addEventListener("shopify:section:load", initDrawerOpenButtons);
document.addEventListener("shopify:section:unload", initDrawerOpenButtons);
document.addEventListener("collection-grid-update", initDrawerOpenButtons);

function bindDrawerCloseButtons() {
  document.querySelectorAll(".drawer_close_btn").forEach((button) => {
    if (button.dataset.closeInitialized) return; // avoid rebinding
    button.dataset.closeInitialized = "true";

    button.addEventListener("click", () => {
      const drawer = button.closest(".drawer_wrapper");
      const section = document.querySelector(".main-product-section");
      if (section) {
        closeDrawer(drawer, section);
        RemoveScrollLock();
      } else {
        closeDrawer(drawer);
        RemoveScrollLock();
      }
    });
  });
}

document.addEventListener("DOMContentLoaded", bindDrawerCloseButtons);
document.addEventListener("shopify:section:load", bindDrawerCloseButtons);
document.addEventListener("collection-grid-update", bindDrawerCloseButtons);

drawers.forEach((drawer) => {
  drawer.addEventListener("click", (event) => {
    const section = document.querySelector(".main-product-section");
    if (event.target === drawer) {
      if (section) {
        closeDrawer(drawer, section);
        RemoveScrollLock();
      } else {
        closeDrawer(drawer);
        RemoveScrollLock();
      }
    }
  });

  drawer.addEventListener("keydown", (event) => {
    const section = document.querySelector(".main-product-section");
    if (event.key === "Escape") {
      if (section) {
        closeDrawer(drawer, section);
        RemoveScrollLock();
      } else {
        closeDrawer(drawer);
        RemoveScrollLock();
      }
    }
  });
});


// SEARCH DRAWER
class SearchDrawer extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector("#search_drawer_input");
    this.emptyWrapper = this.querySelector(".search_drawer_empty");
    this.resultsWrapper = this.querySelector(".search_results_wrapper");
    this.resultsInner = this.querySelector(".search_results_inner");
    this.reset = this.querySelector(".search_drawer_reset_btn");
    this.status = this.querySelector("[data-search-status]");
    this.drawer = this.closest(".drawer_wrapper");
  }

  connectedCallback() {
    if (!this.input) return;

    this.input.addEventListener(
      "input",
      this.debounce(this.handleUserInput.bind(this), 300),
    );

    this.input.addEventListener("keydown", (e) => {
      if (e.key === "Enter") {
        e.preventDefault();
        const q = this.input.value.trim();
        if (q) {
          window.location.href = `${window.Shopify.routes.root}search?q=${encodeURIComponent(q)}&options[prefix]=last`;
        }
      }
    });

    this.reset?.addEventListener("click", this.handleInputReset.bind(this));
    this.addEventListener("keydown", this.handleArrowNavigation.bind(this));
    this.initTypewriter();
    this.initDrawerPosition();
  }

  /* == Typewriter placeholder start == */
  initTypewriter() {
    this.typeText = this.input.dataset.typewriter || "";
    this.typeIndex = 0;
    this.typeDeleting = false;
    this.typeTimer = null;
    this.typeStopped = false;
    if (!this.typeText || window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      this.typeStopped = true;
      return;
    }

    this.input.placeholder = "";
    this.input.addEventListener("input", () => this.stopTypewriter(), { once: true });
  }

  startTypewriter() {
    if (this.typeStopped || this.typeTimer) return;
    this.typeStep();
  }

  typeStep() {
    if (this.typeStopped) return;

    this.typeIndex += this.typeDeleting ? -1 : 1;
    this.input.placeholder = this.typeText.slice(0, this.typeIndex);

    if (!this.typeDeleting && this.typeIndex >= this.typeText.length) {
      this.typeDeleting = true;
      this.typeTimer = setTimeout(() => this.typeStep(), 2000);
      return;
    }

    if (this.typeDeleting && this.typeIndex <= 0) {
      this.typeDeleting = false;
      this.typeTimer = setTimeout(() => this.typeStep(), 600);
      return;
    }

    this.typeTimer = setTimeout(() => this.typeStep(), this.typeDeleting ? 35 : 80);
  }

  pauseTypewriter() {
    clearTimeout(this.typeTimer);
    this.typeTimer = null;
  }

  stopTypewriter() {
    this.typeStopped = true;
    this.pauseTypewriter();
    this.input.placeholder = "";
  }
  /* == Typewriter placeholder end == */


  initDrawerPosition() {
    if (!this.drawer) return;

    this.updateDrawerOffset = this.updateDrawerOffset.bind(this);
    this.updateDrawerOffset();

    window.addEventListener("resize", this.updateDrawerOffset, {
      passive: true,
    });
    window.addEventListener("scroll", this.updateDrawerOffset, {
      passive: true,
    });

    
    this.drawerObserver = new MutationObserver(() => {
      // typewriter only runs while the drawer is open
      if (!this.drawer.classList.contains("active")) {
        this.pauseTypewriter();
        return;
      }
      this.updateDrawerOffset();
      this.startTypewriter();
      requestAnimationFrame(() => this.input.focus());
    });
    this.drawerObserver.observe(this.drawer, {
      attributes: true,
      attributeFilter: ["class"],
    });
  }

  disconnectedCallback() {
    this.pauseTypewriter();
    if (!this.updateDrawerOffset) return;
    window.removeEventListener("resize", this.updateDrawerOffset);
    window.removeEventListener("scroll", this.updateDrawerOffset);
    this.drawerObserver?.disconnect();
  }

  updateDrawerOffset() {
    if (!this.drawer.classList.contains("active")) return;

    const header = document.querySelector("main-header");
    const offset = header
      ? Math.max(0, Math.round(header.getBoundingClientRect().bottom))
      : 0;

    this.drawer.style.setProperty("--search-drawer-offset", `${offset}px`);
  }

  announce(message) {
    if (!this.status || !message) return;
    this.status.textContent = message;
  }

  handleArrowNavigation(e) {
    if (e.key !== "ArrowDown" && e.key !== "ArrowUp") return;

    const items = [
      this.input,
      ...this.querySelectorAll(
        ".search_results_wrapper a, .search_drawer_empty a",
      ),
    ].filter((el) => el.offsetParent !== null || el === this.input);

    const current = items.indexOf(document.activeElement);
    if (current === -1) return;

    e.preventDefault();
    const next =
      e.key === "ArrowDown"
        ? Math.min(current + 1, items.length - 1)
        : Math.max(current - 1, 0);

    items[next]?.focus();
  }

  debounce(fn, delay = 300) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), delay);
    };
  }

  toggleResetBtn(show) {
    if (!this.reset) return;
    this.reset.classList.toggle("hidden", !show);
  }

  toggleSearchView(showEmpty) {
    this.emptyWrapper?.classList.toggle("hidden", !showEmpty);
    this.resultsWrapper?.classList.toggle("hidden", showEmpty);
    this.input?.setAttribute("aria-expanded", showEmpty ? "false" : "true");
  }

  handleInputReset(e) {
    e.preventDefault();
    this.input.value = "";
    if (this.typeStopped && this.typeText) this.input.placeholder = this.typeText;
    this.toggleResetBtn(false);
    this.toggleSearchView(true);
    this.resultsInner.innerHTML = "";
    this.classList.remove("is-loading");
    this.announce("");
    this.input.focus();
  }

  handleUserInput() {
    const q = this.input.value.trim();

    this.toggleResetBtn(q.length > 0);

    if (!q) {
      this.toggleSearchView(true);
      this.announce("");
      return;
    }

    this.setLoading(true);

    fetch(
      `${window.Shopify.routes.root}search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product,collection,article,page,query`,
    )
      .then((res) => res.json())
      .then((data) => {
        this.setLoading(false);
        this.renderResults(data.resources?.results || {});
      })
      .catch((err) => {
        this.setLoading(false);
        console.error("Search error:", err);
      });
  }

  setLoading(isLoading) {
    this.classList.toggle("is-loading", isLoading);

    if (isLoading) {
      this.toggleSearchView(false);
      this.resultsInner.innerHTML = this.getLoadingMarkup();
      this.announce(this.dataset.statusLoading);
    }
  }

  getLoadingMarkup() {
    return `
      <div class="search_drawer_loading">
        <div class="skeleton"></div>
        <div class="skeleton"></div>
        <div class="skeleton"></div>
      </div>
    `;
  }

  renderResults(results) {
    const {
      products = [],
      collections = [],
      articles = [],
      pages = [],
      queries = [],
    } = results;

    this.toggleSearchView(false);
    this.resultsInner.innerHTML = "";

    const addGroup = (title, html) => {
      const group = document.createElement("div");
      group.className = "search_result_block";
      group.innerHTML = `<h3 class="h6">${title}</h3>${html}`;
      this.resultsInner.appendChild(group);
    };

    if (queries.length) {
      addGroup(
        "Suggestions",
        queries
          .map((q) => `<p><a href="${q.url}">${q.styled_text}</a></p>`)
          .join(""),
      );
    }

    if (collections.length) {
      addGroup(
        "Collections",
        collections
          .map((c) => `<p><a href="${c.url}">${c.title}</a></p>`)
          .join(""),
      );
    }

    if (products.length) {
      addGroup(
        "Products",
        products
          .map(
            (p) => `
            <div class="search_result_product_card">
              <div class="search_result_product_card_img ratio" style="--aspect-ratio: 100%;">
                <a href="${p.url}">
                  <img src="${p.featured_image?.url || "null"}" alt="${p.title}">
                </a>
              </div>
              <div class="search_result_product_card_info">
                <h4 class="small-text"><a href="${p.url}">${p.title}</a></h4>
                <div class="search_result_product_price">
                  <p>${Shopify.formatMoney(p.price_min)}</p>
                  ${p.compare_at_price_min > p.price_min
                ? `<s>${Shopify.formatMoney(p.compare_at_price_min)}</s>`
                : ""
              }
                </div>
              </div>
            </div>
          `,
          )
          .join(""),
      );
    }

    if (articles.length) {
      addGroup(
        "Articles",
        articles
          .map(
            (a) => `
            <div class="search_result_article_card">
            <div class="search_result_article_card_img ratio" style="--aspect-ratio: 100%;">
                <a href="${a.url}">
                  <img src="${a.image || "null"}" alt="${a.title}">
                </a>
              </div>
              <div class="search_result_article_card_info">
                <h4 class="small-text"><a href="${a.url}">${a.title}</a></h4>
              </div>
            </div>
          `,
          )
          .join(""),
      );
    }

    if (pages.length) {
      addGroup(
        "Pages",
        pages.map((p) => `<p><a href="${p.url}">${p.title}</a></p>`).join(""),
      );
    }

    if (
      !queries.length &&
      !collections.length &&
      !products.length &&
      !articles.length &&
      !pages.length
    ) {
      this.resultsInner.innerHTML = `<h6 class="empty_results_heading">${this.dataset.statusEmpty || "No results found."}</h6>`;
      this.announce(this.dataset.statusEmpty);
      return;
    }

    this.announce(this.dataset.statusResults);
  }
}

customElements.define('search-drawer', SearchDrawer);



// COLLECTION SORTING
class CollectionSorting extends HTMLElement {
  constructor() {
    super();

    this.form = this.querySelector('form#main_collection_sort_form');
    this.select = this.querySelector('select[name="sort_by"]');
    this.sectionId = this.dataset.sectionId;

    this.isLoading = false;
  }

  connectedCallback() {
    this.select.addEventListener('change', () => {
      const value = this.select.value;

      this.isLoading = true;
      this.showLoaderSkeleton();
      this.disableFilters();

      const url = new URL(window.location.href, window.location.origin);
      url.searchParams.set('sort_by', value);
      url.searchParams.set('sections', this.sectionId);

      this.updatePage(url, this.sectionId);

      this.updateURL(url);
    })
  }

  showLoaderSkeleton() {
    const grid = document.querySelector(".main_collection_product_grid_wrapper") || document.querySelector('.main_search_results_grid_wrapper');
    if (!grid) return;

    grid.classList.add("is-loading");
    grid.setAttribute("aria-busy", "true");
  }

  hideLoaderSkeleton() {
    const grid = document.querySelector(".main_collection_product_grid_wrapper") || document.querySelector('.main_search_results_grid_wrapper');
    if (!grid) return;

    grid.classList.remove("is-loading");
    grid.removeAttribute("aria-busy");
  }

  disableFilters() {
    const filters = this.closest(".main_collection_filters");
    if (!filters) return;

    filters.setAttribute("inert", "");
    filters.classList.add("is-loading");
  }

  enableFilters() {
    const filters = this.closest(".main_collection_filters");
    if (!filters) return;

    filters.removeAttribute("inert");
    filters.classList.remove("is-loading");
  }

  updatePage(url, id) {
    const wasFilterOpen = this.closest(
      ".main_collection_filters",
    )?.classList.contains("active");

    fetch(url.toString())
      .then((res) => res.json())
      .then((htmlString) => {
        const temp = document.createElement("div");
        temp.innerHTML = htmlString[id];

        const newWrapper = temp.querySelector(".main_collection_inner_wrapper") || temp.querySelector('.main_search_inner_wrapper');
        const oldWrapper = document.querySelector(".main_collection_inner_wrapper") || document.querySelector('.main_search_inner_wrapper');

        if (oldWrapper && newWrapper) {
          oldWrapper.innerHTML = newWrapper.innerHTML;

          if (wasFilterOpen) {
            const filterWrapper = document.querySelector(
              ".main_collection_filters",
            );
            const gridWrapper = document.querySelector(
              ".main_collection_product_grid_wrapper",
            );

            if (filterWrapper && gridWrapper) {
              filterWrapper.classList.add("active");
              filterWrapper.removeAttribute("inert");
              gridWrapper.classList.add("padding");
            }
          }
        }

        const newDrawer = temp.querySelector('.collection_filter_drawer');
        const oldDrawer = document.querySelector('.collection_filter_drawer');

        if (oldDrawer && newDrawer) {
          oldDrawer.innerHTML = newDrawer.innerHTML;
        }

        document.dispatchEvent(
          new CustomEvent("collection-grid-update", {
            detail: {
              url: url,
              sectionId: this.sectionId,
            },
          }),
        );
      })
      .catch((err) => {
        console.error("Error: ", err);
      })
      .finally(() => {
        this.hideLoaderSkeleton();
        this.enableFilters();
        this.isLoading = false;
      });
  }

  updateURL(url) {
    url.searchParams.delete("sections");
    window.history.replaceState({}, "", url.toString());
  }
}

customElements.define('collection-sorting', CollectionSorting);


// COLLECTION FILTERS
class CollectionFilters extends HTMLElement {
  constructor() {
    super();

    this.btn = this.querySelector(".collection_filters_apply_button_wrapper button");
    this.form = this.querySelector("#collection_filters_form");
    this.activeValues = this.querySelectorAll(".collection_filter_drawer_active_values_wrapper a");
    this.sectionId = this.dataset.sectionId;

    this.isLoading = false;
  }

  connectedCallback() {
    this.attachListeners();
  }

  attachListeners() {

    /* APPLY BUTTON */
    if (this.btn) {
      this.btn.addEventListener("click", (e) => {
        e.preventDefault();

        if (!this.form) return;

        this.liveUpdate = false;
        this.submitForm();
      });
    } else {
      console.warn("<collection-filters>: apply button not found (.collection_filters_apply_button_wrapper button) — filters cannot be submitted.");
    }

    /* Auto Refresh: Update filters as selections change to keep counts and options accurate. */
    if (this.form) {
      this.form.addEventListener("change", (e) => {
        const field = e.target;
        if (!field || !field.name) return;
        if (field.name === "q" || field.name === "options[prefix]") return;

        this.liveUpdate = true;
        this.submitForm();
      });
    }

    /* REMOVE ACTIVE FILTERS */
    if (this.activeValues.length) {
      this.activeValues.forEach((value) => {
        value.addEventListener("click", (e) => {
          e.preventDefault();

          this.liveUpdate = true;

          const url = new URL(
            e.currentTarget.getAttribute("href"),
            window.location.origin
          );

          this.applyFilters(url.search);
        });
      });
    }
  }

  submitForm() {

    const formData = new FormData(this.form);

    const priceGte = this.form.querySelector('[name="filter.v.price.gte"]');
    const priceLte = this.form.querySelector('[name="filter.v.price.lte"]');

    const defaultMin = priceGte?.getAttribute("data-default");
    const defaultMax = priceLte?.getAttribute("data-default");

    if (priceGte && priceLte && defaultMin && defaultMax) {
      if (priceGte.value === defaultMin && priceLte.value === defaultMax) {
        priceGte.value = "";
        priceLte.value = "";

        formData.delete("filter.v.price.gte");
        formData.delete("filter.v.price.lte");
      }
    }

    const params = new URLSearchParams();

    const currentParams = new URLSearchParams(window.location.search);

    for (const [key, value] of currentParams.entries()) {
      if (key.startsWith("filter.v.") || key.startsWith("filter.p.")) continue;
      if (formData.has(key)) continue;
      params.append(key, value);
    }

    for (const [key, value] of formData.entries()) {
      if (value && value !== "") {
        if (key === "sort_by") {
          params.set(key, value);
        } else {
          params.append(key, value);
        }
      }
    }

    this.applyFilters(`?${params.toString()}`);
  }

  /* filter ajax start */
  applyFilters(search) {
    const basePath = this.dataset.filterUrl || window.location.pathname;
    const url = new URL(`${window.location.origin}${basePath}${search}`);

    if (!this.sectionId) {
      this.hardRedirect(url);
      return;
    }

    const fetchUrl = new URL(url.toString());
    fetchUrl.searchParams.set("sections", this.sectionId);

    this.showLoaderSkeleton();

    if (this.controller) this.controller.abort();
    this.controller = new AbortController();

    fetch(fetchUrl.toString(), { signal: this.controller.signal })
      .then((res) => res.json())
      .then((data) => {
        const markup = data[this.sectionId];
        if (!markup) {
          this.hardRedirect(url);
          return;
        }

        const temp = document.createElement("div");
        temp.innerHTML = markup;

        const newWrapper = temp.querySelector(".main_collection_inner_wrapper") || temp.querySelector(".main_search_inner_wrapper");
        const oldWrapper = document.querySelector(".main_collection_inner_wrapper") || document.querySelector(".main_search_inner_wrapper");

        const newDrawer = temp.querySelector(".collection_filter_drawer");
        const oldDrawer = document.querySelector(".collection_filter_drawer");

        if (oldWrapper && newWrapper) {
          oldWrapper.innerHTML = newWrapper.innerHTML;
        }

        if (oldDrawer && newDrawer) {
          const activeId = document.activeElement ? document.activeElement.id : null;
          const oldScroller = oldDrawer.querySelector(".drawer_wrapper_inner");
          const scrollTop = oldScroller ? oldScroller.scrollTop : 0;

          oldDrawer.innerHTML = newDrawer.innerHTML;

          if (this.liveUpdate) {
            const newScroller = oldDrawer.querySelector(".drawer_wrapper_inner");
            if (newScroller) newScroller.scrollTop = scrollTop;

            if (activeId) {
              const restored = oldDrawer.querySelector(`#${CSS.escape(activeId)}`);
              if (restored && !restored.disabled) restored.focus();
            }
          } else {
            closeDrawer(oldDrawer);
            RemoveScrollLock();
          }
        }

        window.history.replaceState({}, "", url.toString());

        document.dispatchEvent(
          new CustomEvent("collection-grid-update", {
            detail: {
              url: url,
              sectionId: this.sectionId,
            },
          }),
        );
      })
      .catch((err) => {
        if (err.name === "AbortError") return;
        console.error("Error: ", err);
        this.hardRedirect(url);
      })
      .finally(() => {
        this.hideLoaderSkeleton();
        this.isLoading = false;
        this.liveUpdate = false;
      });
  }

  hardRedirect(url) {
    window.location.href = url.toString();
  }

  showLoaderSkeleton() {
    const grid = document.querySelector(".main_collection_product_grid_wrapper") || document.querySelector(".main_search_results_grid_wrapper");
    if (!grid) return;

    grid.classList.add("is-loading");
    grid.setAttribute("aria-busy", "true");
  }

  hideLoaderSkeleton() {
    const grid = document.querySelector(".main_collection_product_grid_wrapper") || document.querySelector(".main_search_results_grid_wrapper");
    if (!grid) return;

    grid.classList.remove("is-loading");
    grid.removeAttribute("aria-busy");
  }
  /* filter ajax end */
}

if (!customElements.get("collection-filters")) {
  customElements.define("collection-filters", CollectionFilters);
}


document.addEventListener("collection-grid-update", () => {
  if (!scrollReveal) return;

  const wrapper = document.querySelector(".main_collection_inner_wrapper") || document.querySelector('.main_search_inner_wrapper');
  if (!wrapper) return;

  scrollReveal.initElements(wrapper);
});


// CLEAR SEARCH BUTTON
class ClearSearchButton extends HTMLElement {
  constructor() {
    super();
    this.form = this.closest('form[role="search"]');
    this.btn = this.querySelector('.clear_search');
  }

  connectedCallback() {
    this.btn.addEventListener('click', this.handleClick.bind(this));
  }

  handleClick(e) {
    e.preventDefault();
    const url = new URL(window.location.href);
    url.search = '';
    window.location.href = url.toString();
  }
}

customElements.define('clear-search-button', ClearSearchButton);


// CART QUANTITY PICKER
class CartQuantityPicker extends HTMLElement {
  constructor() {
    super();

    this.btnMinus = this.querySelector("[data-minus]");
    this.input = this.querySelector('input[type="text"]');
    this.btnPlus = this.querySelector("[data-plus]");
    this.inputValue = Number(this.input.value);
    this.step = Number(this.input.getAttribute("step"));
    this.min = this.input.dataset.min;
    this.max = this.input.dataset.max;
    this.line = this.dataset.line;
  }

  connectedCallback() {
    this.btnMinus.addEventListener("click", this.handleChange.bind(this));
    this.btnPlus.addEventListener("click", this.handleChange.bind(this));
    const debouncedInputandler = debounce((e) => this.handleInput(e), 1000);
    this.input.addEventListener("input", () => this.sanitize());
    this.input.addEventListener("input", debouncedInputandler);
    this.input.addEventListener("change", (e) => this.handleCommit(e));
    this.input.addEventListener("blur", (e) => this.handleCommit(e));
  }

  sanitize() {
    const raw = this.input.value;
    const cleaned = raw.replace(/[^0-9]/g, "");
    if (cleaned === raw) return;

    const caret = this.input.selectionStart;
    this.input.value = cleaned;

    if (caret !== null) {
      const next = Math.max(0, caret - (raw.length - cleaned.length));
      try {
        this.input.setSelectionRange(next, next);
      } catch (error) {
        /* input does not support selection */
      }
    }
  }

  handleCommit(e) {
    if (this.input.value.trim() !== "") return;
    this.input.value = Number(this.min) || 1;
    this.handleInput(e);
  }

  handleChange(e) {
    if (e.currentTarget.hasAttribute("data-plus")) {
      this.inputValue = this.inputValue + this.step;
      this.input.value = this.inputValue;
    } else {
      this.inputValue = this.inputValue - this.step;
      this.input.value = this.inputValue;
    }

    if (this.min) {
      if (this.inputValue <= this.min) {
        this.btnMinus.setAttribute("disabled", "");
      } else {
        this.btnMinus.removeAttribute("disabled");
      }
    }

    if (this.max) {
      if (this.inputValue >= this.max) {
        this.btnMinus.setAttribute("disabled", "");
      } else {
        this.btnPlus.removeAttribute("disabled");
      }
    }

    document.dispatchEvent(
      new CustomEvent("cart-quantity-changed", {
        detail: {
          value: this.inputValue,
          line: this.line,
        },
        bubbles: true,
        composed: true,
      }),
    );
  }

  handleInput(e) {
    if (this.input.value.trim() === "") return;

    this.value = Number(this.input.value);
    if (this.value == 0) {
      this.value = 1;
      this.input.value = 1;
    }

    if (this.min) {
      if (this.value <= this.min) {
        this.btnMinus.setAttribute("disabled", "");
      } else {
        this.btnMinus.removeAttribute("disabled");
      }
    }

    if (this.max) {
      if (this.value >= this.max) {
        this.btnMinus.setAttribute("disabled", "");
      } else {
        this.btnMinus.removeAttribute("disabled");
      }
    }

    this.dispatchEvent(
      new CustomEvent("cart-quantity-changed", {
        detail: {
          value: this.value,
          line: this.line,
        },
        bubbles: true,
        composed: true,
      }),
    );
  }
}

customElements.define('cart-quantity-picker', CartQuantityPicker);


// CART ITEM REMOVE
class ItemRemove extends HTMLElement {
  constructor() {
    super();
    this.line = this.dataset.line;
    this.removeBtn = this.querySelector(".item_remove_btn");
  }

  connectedCallback() {
    this.removeBtn.addEventListener("click", this.handleClick.bind(this));
  }

  handleClick(e) {
    e.preventDefault();

    document.dispatchEvent(
      new CustomEvent("cart-item-removed", {
        detail: {
          value: 0,
          line: this.line,
        },
        bubbles: true,
        composed: true,
      }),
    );
  }
}

customElements.define('item-remove', ItemRemove);


// CART DISCOUNT INPUT
class CartDiscountInput extends HTMLElement {
  constructor() {
    super();

    this.discountInput = this.querySelector('input[name="discount"]');
    this.value = this.discountInput ? this.discountInput.value : "";
    this.btn = this.querySelector('button[name="cdi_discount_btn"]');
    this.removeButtons = Array.from(this.querySelectorAll("[data-cart-discount-remove]"));
    this.remove = this.removeButtons[0];
    this.error = this.querySelector(".cdi_discount_error");
    this.toggleBtn = this.querySelector(".cdi_discount_toggle_btn");
    this.accordion = this.querySelector(".cdi_discount_accordion");

    this.debounceTimer = null;
  }

  connectedCallback() {
    this.discountInput?.addEventListener("input", this.handleInput.bind(this));
    this.btn?.addEventListener("click", this.handleClick.bind(this));
    this.toggleBtn?.addEventListener("click", this.handleToggleClick.bind(this));
    if (!this.removeButtons.length) return;
    this.removeButtons.forEach((button) => {
      button.addEventListener("click", this.handleRemove.bind(this));
    });
  }

  getAppliedCodes() {
    return Array.from(this.querySelectorAll("[data-discount-code]"))
      .map((element) => element.dataset.discountCode.trim())
      .filter(Boolean);
  }

  handleToggleClick() {
    if (!this.accordion) return;

    const isOpen = this.accordion.hasAttribute("open");

    if (isOpen) {
      this.accordion.removeAttribute("open");
      this.toggleBtn?.setAttribute("aria-expanded", "false");
    } else {
      this.accordion.setAttribute("open", "");
      this.toggleBtn?.setAttribute("aria-expanded", "true");
      this.discountInput?.focus();
    }
  }

  handleInput() {
    if (this.error) {
      this.error.classList.add("hidden");
    }

    this.value = this.discountInput.value.trim();
  }

  handleClick(e) {
    e.preventDefault();

    if (!this.value) {
      if (this.error) {
        this.error.classList.remove("hidden");

        this.discountInput.focus();
        return;
      }
    }

    const codes = this.getAppliedCodes();

    if (
      this.value &&
      !codes.some((code) => code.toLowerCase() === this.value.toLowerCase())
    ) {
      codes.push(this.value);
    }

    document.dispatchEvent(
      new CustomEvent("discount-button-clicked", {
        detail: {
          discount: codes.join(","),
        },
        bubbles: true,
        composed: true,
      }),
    );
  }

  handleRemove(e) {
    e.preventDefault();

    const chip = e.currentTarget.closest("[data-discount-code]");
    const removed = chip ? chip.dataset.discountCode.trim().toLowerCase() : "";
    const remaining = this.getAppliedCodes().filter(
      (code) => code.toLowerCase() !== removed,
    );

    document.dispatchEvent(
      new CustomEvent("discount-remove-clicked", {
        detail: {
          discount: removed ? remaining.join(",") : "",
        },
        bubbles: true,
        composed: true,
      }),
    );
  }
}

customElements.define('cart-discount-input', CartDiscountInput);


// CART NOTE
class CartNote extends HTMLElement {
  constructor() {
    super();

    this.cartNoteBtn = this.querySelector(".cdi_cart_note_btn");
    this.cartNoteWrapper = this.querySelector('.cdi_cart_note_inner')
    this.textarea = this.querySelector("textarea");
  }


  connectedCallback() {
    if (this.cartNoteBtn) {
      this.cartNoteBtn.addEventListener("click", this.handleNoteClick.bind(this));
    }

    this.textarea?.addEventListener("input", () => {
      clearTimeout(this.debounceTimer);

      this.debounceTimer = setTimeout(() => {
        this.updateCartNote(this.textarea.value.trim());
      }, 500);
    });
  }

  handleNoteClick() {
    const isOpen = this.cartNoteWrapper.hasAttribute("open");

    if (isOpen) {
      this.closeNote();
    } else {
      this.openNote();
    }
  }

  openNote() {
    this.cartNoteWrapper.setAttribute("open", "");
    this.cartNoteBtn?.setAttribute("aria-expanded", "true");
    this.textarea.removeAttribute("inert");
    this.textarea.setAttribute("aria-hidden", "false");
    this.textarea.focus();
  }

  closeNote() {
    this.cartNoteWrapper.removeAttribute("open");
    this.cartNoteBtn?.setAttribute("aria-expanded", "false");
    this.textarea.setAttribute("inert", "");
    this.textarea.setAttribute("aria-hidden", "true");
  }

  updateCartNote(value) {
    fetch(`${window.Shopify.routes.root}cart/update.js`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ note: value }),
    }).catch((err) => {
      console.error("Error updating cart note:", err);
    });
  }
}

customElements.define('cart-note', CartNote);


// CART CONTROLLER
class CartController {
  static init() {
    this.locked = false;

    document.addEventListener("cart-quantity-changed", (e) =>
      this.updateLine(e.detail.line, e.detail.value)
    );

    document.addEventListener("cart-item-removed", (e) =>
      this.updateLine(e.detail.line, 0)
    );

    document.addEventListener("discount-button-clicked", (e) =>
      this.updateDiscount(e.detail.discount)
    );

    document.addEventListener("discount-remove-clicked", (e) =>
      this.updateDiscount(e.detail.discount)
    );

    document.addEventListener("cart-note-change", (e) =>
      this.updateNote(e.detail.note)
    );
  }

  static startLoading() {
    document.dispatchEvent(
      new CustomEvent("cart-loading", {
        detail: { loading: true },
        bubbles: true,
      })
    );
  }

  static stopLoading() {
    document.dispatchEvent(
      new CustomEvent("cart-loading", {
        detail: { loading: false },
        bubbles: true,
      })
    );
  }

  static async updateLine(line, quantity) {
    if (this.locked) return;
    this.locked = true;
    this.startLoading();

    try {
      const res = await fetch(`${window.Shopify.routes.root}cart/change.js`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          line,
          quantity,
          sections: "cart-drawer,cart,cart-bubble",
        }),
      });

      const data = await res.json();

      if (!res.ok) {
        const sections = await fetch(
          `${window.Shopify.routes.root}?sections=cart-drawer,cart,cart-bubble`
        ).then((r) => r.json());

        document.dispatchEvent(
          new CustomEvent("cart-updated", {
            detail: {
              line,
              message: data.message || data.description,
              sections,
            },
            bubbles: true,
          })
        );

        return;
      }

      this.dispatchUpdate(data);
    } catch (err) {
      console.error("Cart line update failed:", err);
    } finally {
      this.locked = false;
      this.stopLoading();
    }
  }

  static async updateDiscount(discount) {
    if (this.locked) return;
    this.locked = true;
    this.startLoading();

    try {
      const res = await fetch(`${window.Shopify.routes.root}cart/update.js`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          discount,
          sections: "cart-drawer,cart,cart-bubble",
        }),
      });

      const data = await res.json();

      const discountData = data.discount_codes?.[0];

      if (discount && discountData && discountData.applicable === false) {
        document.dispatchEvent(
          new CustomEvent("cart-discount-error", {
            detail: {
              message: "Invalid or expired discount code",
            },
            bubbles: true,
          })
        );
        return;
      }

      this.dispatchUpdate(data);
    } catch (err) {
      console.error(err);
    } finally {
      this.locked = false;
      this.stopLoading();
    }
  }

  static async updateNote(note) {
    if (this.locked) return;
    this.locked = true;
    this.startLoading();

    try {
      const res = await fetch(`${window.Shopify.routes.root}cart/update.js`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          note,
          sections: "cart-drawer,cart",
        }),
      });

      const data = await res.json();
      this.dispatchUpdate(data);
    } catch (err) {
      console.error(err);
    } finally {
      this.locked = false;
      this.stopLoading();
    }
  }

  static dispatchUpdate(data) {
    document.dispatchEvent(
      new CustomEvent("cart-updated", {
        detail: data,
        bubbles: true,
      })
    );
  }
}

CartController.init();


// CART DRAWER
class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.inner = this.querySelector(".cart_drawer_inner") || this.querySelector('.main_cart_contents_wrapper');

    this.handleUpdate = updateCart.bind(this);
    this.handleLoading = this.handleLoading.bind(this);
    this.handleDiscountError = this.handleDiscountError.bind(this);
  }

  connectedCallback() {
    document.addEventListener("cart-updated", this.handleUpdate);
    document.addEventListener("cart-loading", this.handleLoading);
    document.addEventListener("cart-discount-error", this.handleDiscountError);
    this.querySelector('input[name="discount"]')
      ?.addEventListener("input", () => {
        this.querySelector(".cdi_discount_error")?.classList.add("hidden");
      });
  }

  disconnectedCallback() {
    document.removeEventListener("cart-updated", this.handleUpdate);
    document.removeEventListener("cart-loading", this.handleLoading);
    document.removeEventListener("cart-discount-error", this.handleDiscountError);
  }

  handleLoading(e) {
    if (!this.inner) return;
    this.inner.classList.toggle("loading", e.detail.loading);
  }

  handleDiscountError(e) {
    const error = this.querySelector(".cdi_discount_error");
    const input = this.querySelector('input[name="discount"]');

    if (!error) return;

    error.textContent = e.detail.message;
    error.classList.remove("hidden");

    if (input) input.value = "";
  }
}

customElements.define("cart-drawer", CartDrawer);

function getFreeShippingCurrencyRate(fallbackRate = 1) {
  const storefrontRate =
    window.Shopify?.currency?.rate || window.Shopify?.Currency?.rate;
  const parsedRate = Number(storefrontRate);

  if (!Number.isNaN(parsedRate) && parsedRate > 0) {
    return parsedRate;
  }

  return fallbackRate;
}

function formatFreeShippingAmount(amount, currencyCode, locale) {
  if (currencyCode && window.Intl?.NumberFormat) {
    try {
      return new Intl.NumberFormat(locale || undefined, {
        style: "currency",
        currency: currencyCode,
      }).format(amount);
    } catch (error) {
      console.warn("Unable to format free shipping amount with Intl.", error);
    }
  }

  return Shopify.formatMoney(Math.round(amount * 100));
}

function celebrateFreeShipping(freeShippingBar) {
  const container = freeShippingBar?.closest(
    ".cart_drawer_inner, .main_cart_contents_wrapper"
  );
  const layer = container?.querySelector(
    ".cart_drawer_confetti_layer, .main_cart_confetti_layer"
  );

  if (!layer) return;

  layer.innerHTML = "";

  const colors = [
    "#180D05",
    "#180D05",
    "#180D05",
    "#180D05",
    "#180D05",
    "#180D05",
    "#180D05",
    "#180D05",
  ];
  const shapes = ["", "cart_drawer_confetti_piece--square", "cart_drawer_confetti_piece--circle"];
  const totalPieces = 50;

  for (let index = 0; index < totalPieces; index += 1) {
    const piece = document.createElement("span");
    const size = 0.55 + Math.random() * 0.7;
    const x = -16 + Math.random() * 32;
    const y = 18 + Math.random() * 28;
    const left = 8 + Math.random() * 84;
    const rotate = 120 + Math.random() * 260;
    const duration = 1000 + Math.random() * 500;
    const color = colors[index % colors.length];
    const shape = shapes[index % shapes.length];

    piece.className = `cart_drawer_confetti_piece ${shape}`.trim();
    piece.style.setProperty("--confetti-size", `${size}rem`);
    piece.style.setProperty("--confetti-left", `${left}%`);
    piece.style.setProperty("--confetti-x", `${x}rem`);
    piece.style.setProperty("--confetti-y", `${y}rem`);
    piece.style.setProperty("--confetti-rotate", `${rotate}deg`);
    piece.style.setProperty("--confetti-duration", `${duration}ms`);
    piece.style.setProperty("--confetti-color", color);
    layer.appendChild(piece);
  }

  window.setTimeout(() => {
    layer.innerHTML = "";
  }, 1700);
}

function refreshFreeShippingBar(totalPrice) {
  const freeShippingBar = document.querySelector(".free_shipping_bar");

  if (!freeShippingBar) return;

  const threshold = Number(freeShippingBar.dataset.threshold) || 0;
  const fallbackRate = Number(freeShippingBar.dataset.exchangeRate) || 1;
  const currencyCode = freeShippingBar.dataset.currencyCode;
  const locale = freeShippingBar.dataset.locale;
  const currentTotal =
    typeof totalPrice === "number"
      ? totalPrice
      : Number(freeShippingBar.dataset.cartTotal) || 0;

  if (threshold <= 0) return;

  const rate = getFreeShippingCurrencyRate(fallbackRate);
  const finalThreshold = threshold * rate;
  const remaining = Math.max(finalThreshold - currentTotal, 0);
  const percentage =
    finalThreshold > 0
      ? Math.min((currentTotal / finalThreshold) * 100, 100)
      : 0;

  const shippingMessage = freeShippingBar.querySelector(
    ".free_shipping_bar_message"
  );
  const progressBar = freeShippingBar.querySelector(".free_shipping_bar_fill");
  const spendMoreTemplate =
    freeShippingBar.dataset.spendMoreTemplate ||
    "Spend [amount] more for free shipping!";
  const qualifiedText =
    freeShippingBar.dataset.qualifiedText ||
    "You've qualified for free shipping!";
  const isQualified = remaining <= 0;
  const wasQualified = freeShippingBar.dataset.qualified === "true";

  freeShippingBar.dataset.qualified = String(isQualified);
  freeShippingBar.classList.toggle("is-qualified", isQualified);

  if (shippingMessage) {
    if (!isQualified) {
      const formattedAmount = formatFreeShippingAmount(
        remaining,
        currencyCode,
        locale
      );
      shippingMessage.innerHTML = spendMoreTemplate.replace(
        "[amount]",
        `<strong>${formattedAmount}</strong>`
      );
    } else {
      shippingMessage.innerHTML = `<span class="free_shipping_bar_qualified">${qualifiedText}</span>`;
    }
  }

  if (progressBar) {
    progressBar.style.width = `${percentage}%`;
  }

  if (isQualified && !wasQualified) {
    freeShippingBar.classList.remove("is-free-ship");
    void freeShippingBar.offsetWidth;
    freeShippingBar.classList.add("is-free-ship");
    celebrateFreeShipping(freeShippingBar);

    window.setTimeout(() => {
      freeShippingBar.classList.remove("is-free-ship");
    }, 950);
  }
}


// UPDATE CART
function updateCart(e) {
  const data = e.detail;
  const updatedDrawer = data.sections["cart-drawer"];
  const updatedCartPage = data.sections["cart"];
  const updatedCartBubble = data.sections["cart-bubble"];
  const div = document.createElement("div");
  const pageDiv = document.createElement("div");
  const bubbleDiv = document.createElement("div");
  const errorMsg = e.detail.message;
  const line = e.detail.line;

  // CART DRAWER UPDATE
  if (updatedDrawer) {
    div.innerHTML = updatedDrawer;
  }

  const oldDrawer = document.querySelector('cart-drawer');

  if (oldDrawer) {
    const drawerHeader = oldDrawer.querySelector(".cart_drawer_header h2");
    const drawerContent = oldDrawer.querySelector(".cart_drawer_content_wrapper");

    if (drawerHeader) {
      drawerHeader.innerHTML = div.querySelector(".cart_drawer_header h2").innerHTML;
    }

    // Sync the shipping bar
    const newShippingBar = div.querySelector(".free_shipping_bar");
    const oldShippingBar = oldDrawer.querySelector(".free_shipping_bar");
    if (newShippingBar) {
      if (oldShippingBar) {
        oldShippingBar.replaceWith(newShippingBar);
      } else if (drawerContent) {
        drawerContent.insertAdjacentElement("beforebegin", newShippingBar);
      }
    } else if (oldShippingBar) {
      oldShippingBar.remove();
    }

    if (drawerContent) {
      drawerContent.innerHTML = div.querySelector(".cart_drawer_content_wrapper").innerHTML;

      if (errorMsg && line) {
        const errorWrapper = drawerContent.querySelector(
          `.cart_drawer_error[data-line="${line}"]`,
        );

        if (errorWrapper) {
          errorWrapper.innerHTML = `<p>${errorMsg}</p>`;
          errorWrapper.removeAttribute("hidden");
        }
      }
    }
  }

  // MAIN CART PAGE UPDATE
  if (updatedCartPage) {
    pageDiv.innerHTML = updatedCartPage;
  }

  const oldCartPage = document.querySelector('.main_cart_contents_wrapper');
  const newCartPage = pageDiv.querySelector('.main_cart_contents_wrapper');

  if (oldCartPage && newCartPage) {
    oldCartPage.innerHTML = newCartPage.innerHTML;

    scrollReveal.initElements(oldCartPage);

    if (errorMsg && line) {
      const errorWrapper = oldCartPage.querySelector(`.cart_error[data-line="${line}"]`);

      if (errorWrapper) {
        errorWrapper.innerHTML = `<p>${errorMsg}</p>`
        errorWrapper.removeAttribute('hidden')
      }
    }

  }

  // CART BUBBLE UPDATE
  if (updatedCartBubble) {
    bubbleDiv.innerHTML = updatedCartBubble;
  }

  const oldBubble = document.querySelector(".cart_count_text");
  if (oldBubble) {
    oldBubble.innerHTML = bubbleDiv.querySelector(".cart_count_text").innerHTML;
  }

  if (typeof data.total_price === "number") {
    refreshFreeShippingBar(data.total_price / 100);
  } else if (data.sections?.["cart-drawer"]) {
    const tmpDiv = document.createElement("div");
    tmpDiv.innerHTML = data.sections["cart-drawer"];
    const freshFsb = tmpDiv.querySelector(".free_shipping_bar");
    const freshTotal = freshFsb ? Number(freshFsb.dataset.cartTotal) || undefined : undefined;
    window.setTimeout(() => refreshFreeShippingBar(freshTotal), 500);
  } else {
    refreshFreeShippingBar();
  }
}

document.addEventListener("DOMContentLoaded", () => {
  refreshFreeShippingBar();
});


// QUANTITY PICKER
class QuantityPicker extends HTMLElement {
  constructor() {
    super();
    this.onButtonClick = this.onButtonClick.bind(this);
    this.onInputChange = this.onInputChange.bind(this);
    this.onInputCommit = this.onInputCommit.bind(this);
  }

  connectedCallback() {
    this.btnMinus = this.querySelector("[data-minus]");
    this.btnPlus = this.querySelector("[data-plus]");
    this.input = this.querySelector('input[type="text"]');

    this.step = Number(this.input.step) || 1;
    this.min = Number(this.input.dataset.min) || 1;
    this.max = Number(this.input.dataset.max) || null;

    this.btnMinus.addEventListener("click", this.onButtonClick);
    this.btnPlus.addEventListener("click", this.onButtonClick);
    this.input.addEventListener("input", this.onInputChange);
    this.input.addEventListener("change", this.onInputCommit);
    this.input.addEventListener("blur", this.onInputCommit);

    this.updateButtons();
  }

  get value() {
    return Number(this.input.value) || this.min;
  }

  clamp(val) {
    return this.max
      ? Math.min(Math.max(val, this.min), this.max)
      : Math.max(val, this.min);
  }

  set value(val) {
    const clamped = this.clamp(val);

    this.input.value = clamped;
    this.updateButtons();
    this.emitChange(clamped);
  }

  onButtonClick(e) {
    if (e.currentTarget === this.btnPlus) {
      this.value = this.value + this.step;
    } else {
      this.value = this.value - this.step;
    }
  }

  sanitize() {
    const raw = this.input.value;
    const cleaned = raw.replace(/[^0-9]/g, "");
    if (cleaned === raw) return;

    const caret = this.input.selectionStart;
    this.input.value = cleaned;

    if (caret !== null) {
      const next = Math.max(0, caret - (raw.length - cleaned.length));
      try {
        this.input.setSelectionRange(next, next);
      } catch (error) {
        /* input does not support selection */
      }
    }
  }

  onInputChange() {
    this.sanitize();
    this.updateButtons();
    if (this.input.value.trim() === "") return;
    this.emitChange(this.clamp(this.value));
  }

  onInputCommit() {
    this.value = this.value;
  }

  updateButtons() {
    this.btnMinus.disabled = this.value <= this.min;
    this.btnPlus.disabled = this.max && this.value >= this.max;
  }

  emitChange(value) {
    this.dispatchEvent(
      new CustomEvent("quantity-changed", {
        detail: { value },
        bubbles: true,
        composed: true,
      }),
    );
  }
}

customElements.define("quantity-picker", QuantityPicker);


// VARIANT PICKER
class VariantPicker extends HTMLElement {
  connectedCallback() {
    this.addEventListener("change", this.onChange);
  }

  disconnectedCallback() {
    this.removeEventListener("change", this.onChange);
  }

  onChange = (event) => {
    const selectedOptions = this.selectedOptions;

    /* build-for-combined-listings - shopify plus store */
    const control = event?.target;
    let productUrl = "";
    if (control?.tagName === "SELECT") {
      productUrl = control.selectedOptions[0]?.dataset.productUrl || "";
    } else if (control?.dataset) {
      productUrl = control.dataset.productUrl || "";
    }

    this.dispatchEvent(
      new CustomEvent("variant-changed", {
        detail: { selectedOptions, productUrl },
        bubbles: true,
        composed: true,
      }),
    );
  };

  get selectedOptions() {
    const selectValues = Array.from(this.querySelectorAll("select")).map(
      (select) => select.selectedOptions[0]?.dataset.value,
    );

    const radioValues = Array.from(
      this.querySelectorAll('input[type="radio"]:checked'),
    ).map((radio) => radio.dataset.value);

    return [...selectValues, ...radioValues].filter(Boolean);
  }
}

customElements.define("variant-picker", VariantPicker);


// PRODUCT FORM
class ProductForm extends HTMLElement {
  constructor() {
    super();

    this.handleSubmit = this.handleSubmit.bind(this);
    this.onVariantChange = this.onVariantChange.bind(this);
    this.isSubmitting = false;
  }

  connectedCallback() {
    this.cacheElements();

    this.addEventListener("submit", this.handleSubmit);
    this.addEventListener("variant-changed", this.onVariantChange);
  }

  disconnectedCallback() {
    this.removeEventListener("submit", this.handleSubmit);
    this.removeEventListener("variant-changed", this.onVariantChange);
  }

  cacheElements() {
    this.form = this.querySelector("form");
    this.button = this.querySelector(".product_form_submit_btn");
    this.btnText = this.button?.querySelector(".btn_text");
    this.loader = this.button?.querySelector(".loader");
    this.cart = document.querySelector(".cart_drawer_wrapper");
    this.openDrawer = false;
  }

  onVariantChange() {
    this.cacheElements();
  }

  async handleSubmit(e) {
    if (!e.target.closest("form")) return;

    e.preventDefault();
    e.stopPropagation();

    if (this.isSubmitting) return;
    this.isSubmitting = true;

    this.cacheElements();
    if (!this.form || !this.button) {
      this.isSubmitting = false;
      return;
    }

    this.button.setAttribute("disabled", "disabled");
    this.button.setAttribute("aria-busy", "true");
    this.button.classList.add('loading');

    if (this.btnText) this.btnText.classList.add("hidden");

    if (this.loader) this.loader.classList.remove("hidden");

    try {
      const formData = new FormData(this.form);

      const res = await fetch(`${Shopify.routes.root}cart/add.js`, {
        method: "POST",
        headers: { "X-Requested-With": "XMLHttpRequest" },
        body: formData,
      });

      const data = await res.json();
      if (!res.ok) {
        this.showError(data);
        const sections = await fetch(
          `${Shopify.routes.root}?sections=cart-drawer,cart,cart-bubble`,
        ).then((r) => r.json());

        document.dispatchEvent(
          new CustomEvent("cart-updated", {
            detail: { sections },
            bubbles: true,
          }),
        );
        throw data;
      }

      if (this.cart) {
        const sections = await fetch(
          `${Shopify.routes.root}?sections=cart-drawer,cart,cart-bubble`,
        ).then((r) => r.json());

        document.dispatchEvent(
          new CustomEvent("cart-updated", {
            detail: { sections },
            bubbles: true,
          }),
        );

        this.openDrawer = true;
      } else {
        window.location.href = `${Shopify.routes.root}cart`;
      }
    } catch (err) {
      this.showError(err);
    } finally {
      this.isSubmitting = false;

      if (this.button) {
        this.button.removeAttribute("disabled");
        this.button.removeAttribute("aria-busy");
        this.button.classList.remove('loading');
      }
      if (this.btnText) this.btnText.classList.remove("hidden");

      if (this.loader) this.loader.classList.add("hidden");

      if (this.openDrawer && this.cart) {
        openDrawer(this.cart, this.button);
        AddScrollLock();
      }
    }
  }

  showError(data) {
    const error =
      this.querySelector(".product_add_error") || this.closest(".product_card_wrapper").querySelector(".product_add_error") || this.closest(".complementary_product_card_wrapper").querySelector('.product_add_error');
    if (!error) return;

    let message = "Unable to add product to cart";

    if (data?.errors && typeof data.errors === "object") {
      const formattedErrors = [];

      Object.entries(data.errors).forEach(([field, value]) => {
        let fieldLabel = "";

        if (field === "email") fieldLabel = "Email";

        if (value === "can't be blank") {
          formattedErrors.push(`${fieldLabel} can't be blank`);
        } else if (value === "is invalid") {
          formattedErrors.push(`${fieldLabel} is invalid`);
        } else {
          formattedErrors.push(`${fieldLabel} ${value}`);
        }
      });

      message = formattedErrors.join("<br>");
    } else if (typeof data?.errors === "string") {
      message = data.errors;
    } else if (typeof data?.description === "string") {
      message = data.description;
    } else if (typeof data?.message === "string") {
      message = data.message;
    }

    error.innerHTML = message;
    error.classList.remove("hidden");
  }
}

customElements.define("product-form", ProductForm);


// QUICK ADD BUTTON
class QuickAddButton extends HTMLElement {
  constructor() {
    super();
    this.btn = this.querySelector(".quick_add_btn");
    this.productHandle = this.dataset.productHandle;
  }

  connectedCallback() {
    if (!this.btn) return;
    this.btn.addEventListener("click", this.handleClick.bind(this));
  }

  async handleClick() {
    const drawer = document.querySelector(".quick_add_drawer_wrapper");
    if (!drawer || !this.btn) return;

    const skeleton = drawer.querySelector(".quick_add_skeleton");
    const content = drawer.querySelector(".quick_add_content");

    content.innerHTML = "";
    skeleton.classList.remove("hidden");

    openDrawer(drawer, this.btn);
    AddScrollLock();

    const fetchPromise = fetch(
      `${Shopify.routes.root}products/${this.productHandle}?section_id=quick-add-model`,
    ).then((r) => r.text());

    const delayPromise = new Promise((resolve) => setTimeout(resolve, 1000));

    const [html] = await Promise.all([fetchPromise, delayPromise]);

    const doc = new DOMParser().parseFromString(html, "text/html");
    const newContent = doc.querySelector(".quick_add_content");

    if (!newContent) return;

    skeleton.classList.add("hidden");
    content.innerHTML = newContent.innerHTML;
  }
}

customElements.define("quick-add-button", QuickAddButton);


// QUICK ADD PRODUCT
class QuickAddProduct extends HTMLElement {
  constructor() {
    super();
    this.abortController = null;
    this.cache = new Map();

    this.onQuantityChange = this.onQuantityChange.bind(this);
    this.onVariantChange = this.onVariantChange.bind(this);
    this.productUrl = this.dataset.productUrl;
    this.drawer = document.querySelector(".quick_add_drawer_wrapper");
  }

  connectedCallback() {
    this.addEventListener("quantity-changed", this.onQuantityChange);
    this.addEventListener("variant-changed", this.onVariantChange);
  }

  disconnectedCallback() {
    this.removeEventListener("quantity-changed", this.onQuantityChange);
    this.removeEventListener("variant-changed", this.onVariantChange);
  }

  setLoading(state) {
    if (!this.drawer) return;
    const inner = this.drawer.querySelector(".quick_add_drawer_inner");
    if (inner) {
      inner.classList.toggle("loading", state);
    }
  }

  onQuantityChange(e) {
    const { value } = e.detail;
    const input = this.querySelector('input[name="quantity"]');
    if (input) {
      input.value = value;
    }
  }

  onVariantChange(e) {
    if (!e.detail?.selectedOptions) return;

    this.setLoading(true);

    /* build-for-combined-listings - shopify plus store */
    const siblingUrl = e.detail.productUrl && e.detail.productUrl !== this.productUrl ? e.detail.productUrl : "";

    this.requestedURL = this.buildURL(e.detail.selectedOptions, siblingUrl || this.productUrl);

    this.loadProductInfo(this.requestedURL);
  }

  buildURL(options, baseUrl = this.productUrl) {
    const params = new URLSearchParams();
    if (options.length) {
      params.append("option_values", options.join(","));
    }

    params.append("section_id", "quick-add-model");

    return `${baseUrl}?${params.toString()}`;
  }

  loadProductInfo(url) {
    if (this.abortController) {
      this.abortController.abort();
    }

    if (this.cache.has(url)) {
      const html = this.cache.get(url);
      const doc = new DOMParser().parseFromString(html, "text/html");
      this.updateQuickDrawer(doc);
      this.setLoading(false);
      return;
    }

    this.abortController = new AbortController();

    fetch(url, { signal: this.abortController.signal })
      .then((res) => res.text())
      .then((html) => {
        this.cache.set(url, html);

        const doc = new DOMParser().parseFromString(html, "text/html");
        this.updateQuickDrawer(doc);
      })
      .catch((err) => {
        if (err.name !== "AbortError") {
          console.error("Error loading product info:", err);
        }
      })
      .finally(() => {
        this.setLoading(false);
      });
  }

  updateQuickDrawer(doc) {
    let container = doc.querySelector("#shopify-section-quick-add-model") || doc.body.firstElementChild;

    if (!container) return;

    const previousFocus = document.activeElement;
    const focusId =
      previousFocus && this.contains(previousFocus) ? previousFocus.id : "";

    /* build-for-combined-listings - shopify plus store */
    const swappedModal = container.querySelector("quick-add-product-modal");
    const swappedUrl = swappedModal?.dataset.productUrl;
    if (swappedModal && swappedUrl && swappedUrl !== this.productUrl) {
      this.productUrl = swappedUrl;
      this.dataset.productUrl = swappedUrl;
      this.innerHTML = swappedModal.innerHTML;
      this.restoreFocus(focusId);
      return;
    }

    // UPDATE IMAGES
    const oldImages = this.querySelector(".quick_add_product_images");
    const updatedImages = container.querySelector(".quick_add_product_images");

    if (oldImages && updatedImages) {
      oldImages.innerHTML = updatedImages.innerHTML;
    }

    // UPDATE PRICE
    const oldPrice = this.querySelector(".quick_add_product_price");
    const updatedPrice = container.querySelector(".quick_add_product_price");

    if (oldPrice && updatedPrice) {
      oldPrice.innerHTML = updatedPrice.innerHTML;
    }

    // UPDATE INVENTORY
    const oldInventory = this.querySelector(".quick_add_inventory_wrapper");
    const updatedInventory = container.querySelector(
      ".quick_add_inventory_wrapper",
    );

    if (oldInventory && updatedInventory) {
      oldInventory.innerHTML = updatedInventory.innerHTML;
    }

    // UPDATE VARIANT SELECTOR
    const oldVariantSelector = this.querySelector(
      ".quick_add_variant_picker_wrapper",
    );
    const updatedVariantSelector = container.querySelector(
      ".quick_add_variant_picker_wrapper",
    );

    if (oldVariantSelector && updatedVariantSelector) {
      oldVariantSelector.innerHTML = updatedVariantSelector.innerHTML;
    }

    // UPDATE QUANTITY
    const oldQuantity = this.querySelector(".quick_add_quantity_wrapper");
    const updatedQuantity = container.querySelector(
      ".quick_add_quantity_wrapper",
    );
    const oldMainQty = this.querySelector('input[name="quantity"]');
    const updatedMainQty = container.querySelector('input[name="quantity"]');

    if (oldQuantity && updatedQuantity) {
      oldQuantity.innerHTML = updatedQuantity.innerHTML;
    }

    // // UPDATE ACTION BUTTONS
    const oldActionBtns = this.querySelector(
      ".quick_add_action_buttons_wrapper",
    );
    const updatedActionBtns = container.querySelector(
      ".quick_add_action_buttons_wrapper",
    );

    if (oldActionBtns && updatedActionBtns) {
      oldActionBtns.innerHTML = updatedActionBtns.innerHTML;
    }

    this.restoreFocus(focusId);
  }

  restoreFocus(focusId) {
    if (!focusId) return;
    if (document.activeElement && this.contains(document.activeElement)) return;

    const restored =
      this.querySelector(`[id="${CSS.escape(focusId)}"]`) ||
      this.querySelector(".quick_add_variant_picker_wrapper input:not([disabled])") ||
      this.querySelector(".quick_add_variant_picker_wrapper select:not([disabled])");

    restored?.focus({ preventScroll: true });
  }
}

customElements.define("quick-add-product-modal", QuickAddProduct);


// MAIN PRODUCT
class MainProduct extends HTMLElement {
  constructor() {
    super();
    this.onQuantityChange = this.onQuantityChange.bind(this);
    this.onVariantChange = this.onVariantChange.bind(this);
    this.handleStickyVisibility = this.handleStickyVisibility.bind(this);
    this.handleStickyChangeClick = this.handleStickyChangeClick.bind(this);
    this.productUrl = this.dataset.productUrl;
    this.sectionId = this.dataset.sectionId;
    this.updateUrl = this.dataset.updateUrl === 'true';

    this.cache = new Map();
    this.cacheLimit = 10;
  }

  connectedCallback() {
    this.addEventListener("quantity-changed", this.onQuantityChange);
    this.addEventListener("variant-changed", this.onVariantChange);
    this.initializeStickyAddToCart();
  }

  disconnectedCallback() {
    this.removeEventListener("quantity-changed", this.onQuantityChange);
    this.removeEventListener("variant-changed", this.onVariantChange);
    this.teardownStickyAddToCart();
  }

  onQuantityChange(e) {
    const { value } = e.detail;
    const input = this.querySelector('input[name="quantity"]');
    if (input) {
      input.value = value;
    }
  }

  onVariantChange(e) {
    if (!e.detail?.selectedOptions) return;

    this.lastFocusedSignature = this.getFocusedElementSignature();

    /* build-for-combined-listings - shopify plus store */
    const siblingUrl = e.detail.productUrl && e.detail.productUrl !== this.productUrl ? e.detail.productUrl : "";

    this.requestedURL = this.buildURL(e.detail.selectedOptions, siblingUrl || this.productUrl);

    this.loadProductInfo(this.requestedURL);
  }

  buildURL(options, baseUrl = this.productUrl) {
    const params = [];
    if (options.length) {
      params.push(`option_values=${encodeURIComponent(options.join(","))}`);
    }

    if (this.sectionId) {
      params.push(`section_id=${this.sectionId}`);
    }

    return `${baseUrl}?${params.join("&")}`;
  }

  loadProductInfo(url) {
    if (this.cache.has(url)) {
      this.updateInfo(this.cache.get(url));
      if (this.updateUrl) {
        this.updateURL(this.cache.get(url));
      }
      return;
    }

    fetch(url)
      .then((res) => res.text())
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, "text/html");

        if (this.cache.size >= this.cacheLimit) {
          const firstKey = this.cache.keys().next().value;
          this.cache.delete(firstKey);
        }
        this.cache.set(url, doc);

        this.updateInfo(doc);
        if (this.updateUrl) {
          this.updateURL(doc);
        }

      })
      .catch((err) => {
        console.error("Error loading product info: ", err);
      })
  }

  updateInfo(doc) {
    const container = doc.querySelector("main-product");

    if (!container) return;
    this.innerHTML = container.innerHTML;

    /* build-for-combined-listings - shopify plus store */
    this.syncCombinedListingUrl(container);

    requestAnimationFrame(() => {
      this.restoreFocus(this.lastFocusedSignature);
    });

    this.reinitializePickupAvailability();
    this.initializeStickyAddToCart();
  }

  /* build-for-combined-listings - shopify plus store */
  syncCombinedListingUrl(container) {
    const nextUrl = container?.dataset.productUrl;
    if (!nextUrl || nextUrl === this.productUrl) return;

    this.productUrl = nextUrl;
    this.dataset.productUrl = nextUrl;
  }

  getFocusedElementSignature() {
    const el = document.activeElement;
    if (!this.contains(el)) return null;

    return {
      id: el.id || null,
      name: el.getAttribute("name"),
      value: el.value,
      dataset: { ...el.dataset },
      tag: el.tagName
    };
  }

  reinitializePickupAvailability() {
    const pickupContainer = this.querySelector('[data-store-availability-container]');
    
    if (!pickupContainer) return;

    if (window.Shopify && Shopify.StoreAvailability) {
      new Shopify.StoreAvailability(pickupContainer);
    }

    initDrawerOpenButtons();

    bindDrawerCloseButtons();

    const pickup_drawer = document.querySelector('.pickup_availability_drawer');
    if (pickup_drawer) {
      pickup_drawer.addEventListener("click", (event) => {
        if (event.target === pickup_drawer) {          
            closeDrawer(pickup_drawer);
            RemoveScrollLock();          
        }
      });

      pickup_drawer.addEventListener("keydown", (event) => {
        if (event.key === "Escape") {          
            closeDrawer(pickup_drawer);
            RemoveScrollLock();          
        }
      });
    }    
  }

  restoreFocus(signature) {
    if (!signature) return;

    let target = null;

    if (signature.id) {
      target = this.querySelector(`#${CSS.escape(signature.id)}`);
    }

    if (!target && signature.name) {
      target = this.querySelector(
        `[name="${CSS.escape(signature.name)}"][value="${CSS.escape(signature.value ?? "")}"]`
      );
    }

    if (!target && signature.dataset) {
      for (const [key, val] of Object.entries(signature.dataset)) {
        target = this.querySelector(`[data-${key}="${CSS.escape(val)}"]`);
        if (target) break;
      }
    }

    if (target && typeof target.focus === "function") {
      target.focus({ preventScroll: true });
    }
  }

  updateURL(html) {
    const variantEl = html.querySelector('[data-selected-variant]');
    if (!variantEl) return;

    let variantData;
    try {
      variantData = JSON.parse(variantEl.textContent);
    } catch {
      return;
    }

    if (!variantData?.id) return;

    window.history.replaceState(
      null,
      "",
      `${this.productUrl}?variant=${variantData.id}`
    );

  }

  initializeStickyAddToCart() {
    this.teardownStickyAddToCart();

    this.stickyAddToCart = this.querySelector("[data-sticky-add-to-cart]");
    this.mainAddToCart = this.querySelector("[data-main-add-to-cart]");
    this.variantPickerTarget = this.querySelector("[data-variant-picker-target]");
    this.changeLink = this.querySelector("[data-sticky-change-link]");
    this.footer = document.querySelector(".main_footer_wrapper");

    if (!this.stickyAddToCart || !this.mainAddToCart) return;

    this.changeLink?.addEventListener("click", this.handleStickyChangeClick);
    window.addEventListener("scroll", this.handleStickyVisibility, { passive: true });
    window.addEventListener("resize", this.handleStickyVisibility, { passive: true });
    window.addEventListener("load", this.handleStickyVisibility);

    requestAnimationFrame(() => {
      this.handleStickyVisibility();
    });
  }

  teardownStickyAddToCart() {
    this.changeLink?.removeEventListener("click", this.handleStickyChangeClick);
    window.removeEventListener("scroll", this.handleStickyVisibility);
    window.removeEventListener("resize", this.handleStickyVisibility);
    window.removeEventListener("load", this.handleStickyVisibility);
  }

  handleStickyVisibility() {
    if (!this.stickyAddToCart || !this.mainAddToCart) return;

    const triggerRect = this.mainAddToCart.getBoundingClientRect();
    const stickyHeight = this.stickyAddToCart.offsetHeight || 0;
    const stickyStyles = window.getComputedStyle(this.stickyAddToCart);
    const stickyBottomOffset = parseFloat(stickyStyles.bottom) || 0;
    const stickyTopEdge = window.innerHeight - stickyBottomOffset - stickyHeight;
    const footerRect = this.footer?.getBoundingClientRect();
    const footerOverlapsSticky =
      footerRect && footerRect.top <= stickyTopEdge;
    const shouldShow =
      triggerRect.bottom <= Math.min(stickyHeight * 0.35, 40) && !footerOverlapsSticky;

    this.stickyAddToCart.classList.toggle("is-visible", shouldShow);
    this.stickyAddToCart.setAttribute("aria-hidden", shouldShow ? "false" : "true");
  }

  handleStickyChangeClick(e) {
    if (!this.variantPickerTarget) return;

    e.preventDefault();

    const topOffset = this.getStickyScrollOffset();
    const targetTop =
      this.variantPickerTarget.getBoundingClientRect().top + window.scrollY - topOffset;

    window.scrollTo({
      top: Math.max(targetTop, 0),
      behavior: "smooth",
    });
  }

  getStickyScrollOffset() {
    const rootStyles = getComputedStyle(document.documentElement);
    const cssHeaderHeight = parseFloat(rootStyles.getPropertyValue("--header-height")) || 0;
    const stickyHeaderSelectors = [
      ".shopify-section-group-header-group",
      ".main-header-section",
      "main-header",
    ];

    const stickyHeaderHeight = stickyHeaderSelectors.reduce((maxHeight, selector) => {
      const element = document.querySelector(selector);
      if (!element) return maxHeight;

      const rect = element.getBoundingClientRect();
      const isPinnedToTop = rect.top <= 0 && rect.bottom > 0;

      if (!isPinnedToTop) return maxHeight;

      return Math.max(maxHeight, rect.height);
    }, 0);

    return Math.max(cssHeaderHeight, stickyHeaderHeight) + 24;
  }
}

customElements.define("main-product", MainProduct);


// VIDEO ALT TAG
document.addEventListener('DOMContentLoaded', () => {
  const videos = document.querySelectorAll('video');
  if (videos.length) {
    videos.forEach((video) => {
      const img = video.querySelector('img');
      if (!img) return;
      img.setAttribute('alt', 'Video preview image')
    })
  }
})


// PRODUCT MEDIA
const PRODUCT_EMBED_SELECTOR =
  'iframe[src*="youtube.com"], iframe[src*="youtu.be"], iframe[src*="vimeo.com"]';

/* Play indicator class differs per gallery */
function productMediaIndicator(media) {
  return media.parentElement?.querySelector(".play_btn, .play_video_icon") || null;
}

function toggleProductMediaIndicator(media, isPlaying) {
  const indicator = productMediaIndicator(media);
  if (!indicator) return;

  indicator.classList.toggle("fade_out", isPlaying);
  indicator.classList.toggle("fade", isPlaying);

  const label = isPlaying ? indicator.dataset.labelPause : indicator.dataset.labelPlay;
  if (label) indicator.setAttribute("aria-label", label);
}

function productMediaOverlay(frame) {
  return frame.parentElement?.querySelector(".video_overlay, .external_video_overlay") || null;
}

function postToProductEmbed(frame, action) {
  const isVimeo = frame.src.includes("vimeo.com");
  const message = isVimeo
    ? { method: action }
    : JSON.stringify({ event: "command", func: action === "play" ? "playVideo" : "pauseVideo", args: [] });

  try {
    frame.contentWindow?.postMessage(message, "*");
  } catch (error) {
    /* embed frame not reachable yet */
  }
}

/* Only one media item play at a time */
function pauseProductMediaWithin(root, except = null) {
  root.querySelectorAll("video").forEach((video) => {
    if (video === except) return;
    if (!video.paused) video.pause();
    toggleProductMediaIndicator(video, false);
  });

  root.querySelectorAll(PRODUCT_EMBED_SELECTOR).forEach((frame) => {
    if (frame === except) return;
    const overlay = productMediaOverlay(frame);
    if (overlay) overlay.style.pointerEvents = "all";
    postToProductEmbed(frame, "pause");
  });

  root.querySelectorAll("product-model").forEach((model) => {
    if (model === except) return;
    model.modelViewerUI?.pause();
    model.querySelector("model-viewer")?.pause?.();
  });
}

function pauseAllProductMedia(except = null) {
  pauseProductMediaWithin(document, except);
}

window.pauseAllProductMedia = pauseAllProductMedia;


class ProductMediaGallery extends HTMLElement {
  get mainSwiperSelector() {
    return ".swiper";
  }

  connectedCallback() {
    this.bindMedia();
    this.watchMainSwiper();
  }

  bindMedia() {
    this.querySelectorAll("video").forEach((video) => {
      video.addEventListener("click", (event) => {
        event.preventDefault();
        this.toggleVideo(video);
      });

      /* Covers programmatic playback too */
      video.addEventListener("play", () => {
        pauseAllProductMedia(video);
        toggleProductMediaIndicator(video, true);
      });

      video.addEventListener("pause", () => toggleProductMediaIndicator(video, false));
    });

    this.querySelectorAll(PRODUCT_EMBED_SELECTOR).forEach((frame) => {
      const overlay = productMediaOverlay(frame);
      if (!overlay) return;

      overlay.addEventListener("click", () => {
        pauseAllProductMedia(frame);
        overlay.style.pointerEvents = "none";
        postToProductEmbed(frame, "play");
      });
    });

    this.querySelectorAll("product-model").forEach((model) => {
      model.addEventListener("click", () => pauseAllProductMedia(model));

      model.addEventListener("mouseenter", () => {
        if (typeof lenis !== "undefined" && lenis?.stop) lenis.stop();
        document.documentElement.style.overflow = "auto";
      });

      model.addEventListener("mouseleave", () => {
        if (typeof lenis !== "undefined" && lenis?.start) lenis.start();
        document.documentElement.style.overflow = "unset";
      });
    });

    this.bindPlayToggles();
  }

 
  bindPlayToggles() {
    this.querySelectorAll("[data-media-play-toggle]").forEach((button) => {
      button.addEventListener("click", () => {
        const video = button.parentElement?.querySelector("video");
        if (video) this.toggleVideo(video);
      });
    });
  }


  toggleVideo(video) {
    if (video.paused) {
      video.play().catch(() => {
      });
    } else {
      video.pause();
    }
  }

  watchMainSwiper() {
    const swiperEl = this.querySelector(this.mainSwiperSelector);
    if (!swiperEl) return;

    const waitForSwiper = () => {
      if (!this.isConnected) return;

      if (swiperEl.swiperInstance) {
        this.swiper = swiperEl.swiperInstance;
        this.swiper.on("slideChange", () => pauseAllProductMedia());
        this.onSwiperReady?.();
      } else {
        requestAnimationFrame(waitForSwiper);
      }
    };

    waitForSwiper();
  }
}

/* Desktop gallery */
class ProductMediaDesktop extends ProductMediaGallery {
  connectedCallback() {
    /* media columns: every panel stays visible, so the tab/panel logic is skipped */
    if (this.dataset.mediaStyle === "columns") {
      this.bindMedia();
      return;
    }

    /* media slider */
    this.panels = Array.from(this.querySelectorAll(".product_media_panel"));
    if (!this.panels.length) return;

    this.thumbRail = this.querySelector("[data-media-thumbs]");
    this.thumbs = this.thumbRail
      ? Array.from(this.thumbRail.querySelectorAll('[role="tab"]'))
      : [];

    this.bindMedia();
    this.bindThumbs();
    this.bindStageSwipe();
    this.watchThumbSlider();

    const initialIndex = this.panels.findIndex((panel) => !panel.hidden);
    this.activeIndex = initialIndex < 0 ? 0 : initialIndex;
    this.select(this.activeIndex, { animate: false });
  }

  watchThumbSlider() {
    const rail = this.querySelector(".product_desktop_thumbnail_media.swiper");
    if (!rail || !("ResizeObserver" in window)) return;

    this.thumbResizeObserver = new ResizeObserver(() => {
      const swiper = rail.swiperInstance;
      if (!swiper || swiper.destroyed) return;
      swiper.update();
      this.revealThumb(this.activeIndex || 0);
    });
    this.thumbResizeObserver.observe(rail);
  }

  disconnectedCallback() {
    if (this.thumbResizeObserver) this.thumbResizeObserver.disconnect();
  }

  bindThumbs() {
    if (!this.thumbs.length) return;

    this.thumbs.forEach((thumb, index) => {
      thumb.addEventListener("click", () => this.select(index));
    });

  
    this.thumbRail.addEventListener("keydown", (event) => {
      const lastIndex = this.thumbs.length - 1;
      let target = null;

      switch (event.key) {
        case "ArrowRight":
        case "ArrowDown":
          target = this.activeIndex >= lastIndex ? 0 : this.activeIndex + 1;
          break;
        case "ArrowLeft":
        case "ArrowUp":
          target = this.activeIndex <= 0 ? lastIndex : this.activeIndex - 1;
          break;
        case "Home":
          target = 0;
          break;
        case "End":
          target = lastIndex;
          break;
        default:
          return;
      }

      event.preventDefault();
      this.select(target, { focusThumb: true });
    });
  }

  
  bindStageSwipe() {
    const stage = this.querySelector("[data-media-stage]");
    if (!stage || this.panels.length < 2) return;

    let startX = null;

    stage.addEventListener(
      "pointerdown",
      (event) => {
        startX = event.target.closest("product-model, iframe, video") ? null : event.clientX;
      },
      { passive: true },
    );

    stage.addEventListener(
      "pointerup",
      (event) => {
        if (startX === null) return;

        const distance = event.clientX - startX;
        startX = null;

        if (Math.abs(distance) < 40) return;
        this.select(distance < 0 ? this.activeIndex + 1 : this.activeIndex - 1);
      },
      { passive: true },
    );

    stage.addEventListener("pointercancel", () => {
      startX = null;
    }, { passive: true });
  }

  select(index, { focusThumb = false, animate = true } = {}) {
    const total = this.panels.length;
    const nextIndex = Math.min(Math.max(index, 0), total - 1);
    const nextPanel = this.panels[nextIndex];
    if (!nextPanel) return;

    
    pauseAllProductMedia();

    this.panels.forEach((panel) => {
      const isActive = panel === nextPanel;

      panel.classList.toggle("is_active", isActive);
      panel.toggleAttribute("hidden", !isActive);
    });

    this.thumbs.forEach((thumb, thumbIndex) => {
      const isActive = thumbIndex === nextIndex;

      thumb.classList.toggle("is_active", isActive);
      thumb.setAttribute("aria-selected", isActive ? "true" : "false");
      thumb.tabIndex = isActive ? 0 : -1;
    });

    this.activeIndex = nextIndex;

    if (animate) this.restartReveal(nextPanel);
    this.revealThumb(nextIndex);

    if (focusThumb) this.thumbs[nextIndex]?.focus();

    this.dispatchEvent(
      new CustomEvent("product-media:changed", {
        bubbles: true,
        detail: { index: nextIndex, mediaId: nextPanel.dataset.mediaId },
      }),
    );
  }

  restartReveal(panel) {
    panel.classList.remove("is_active");
    void panel.offsetWidth;
    panel.classList.add("is_active");
  }


  get thumbSwiper() {
    return this.querySelector(".product_desktop_thumbnail_media.swiper")?.swiperInstance || null;
  }

  revealThumb(index) {
    const thumb = this.thumbs[index];
    if (!thumb || !this.thumbRail) return;

    const swiper = this.thumbSwiper;

    if (swiper) {
      const perView = Math.floor(swiper.params.slidesPerView) || 1;
      const first = swiper.activeIndex;

      if (index < first) swiper.slideTo(index);
      else if (index > first + perView - 1) swiper.slideTo(index - perView + 1);
      return;
    }

    if (this.thumbRail.scrollWidth <= this.thumbRail.clientWidth) return;

    const railRect = this.thumbRail.getBoundingClientRect();
    const thumbRect = thumb.getBoundingClientRect();

    if (thumbRect.left >= railRect.left && thumbRect.right <= railRect.right) return;

    this.thumbRail.scrollTo({
      left: this.thumbRail.scrollLeft + (thumbRect.left - railRect.left),
      behavior: "smooth",
    });
  }
}

customElements.define('product-media-desktop', ProductMediaDesktop);


// PRODUCT MOBILE MEDIA
class ProductMobileMedia extends ProductMediaGallery {
  get mainSwiperSelector() {
    return ".product_mobile_main_media.swiper";
  }

  onSwiperReady() {
    this.initModelControls();
  }

  /* Dragging a 3D model must rotate it instead of swiping the gallery */
  initModelControls() {
    this.querySelectorAll("product-model").forEach((model) => {
      model.addEventListener("mousedown", () => this.disableSwiper());
      model.addEventListener("mouseup", () => this.enableSwiper());
      model.addEventListener("mouseleave", () => this.enableSwiper());

      model.addEventListener("touchstart", () => {
        this.disableSwiper();
        document.body.style.overflow = "hidden";
      });

      model.addEventListener("touchend", () => {
        this.enableSwiper();
        document.body.style.overflow = "";
      });

      model.addEventListener(
        "wheel",
        (event) => {
          event.preventDefault();
          event.stopPropagation();
        },
        { passive: false },
      );
    });
  }

  disableSwiper() {
    if (!this.swiper) return;
    this.swiper.allowTouchMove = false;
  }

  enableSwiper() {
    if (!this.swiper) return;
    this.swiper.allowTouchMove = true;
  }
}

customElements.define('product-mobile-media', ProductMobileMedia);


// QUICK ADD PRODUCT MEDIA
class QuickAddProductMedia extends ProductMediaGallery {
  get mainSwiperSelector() {
    return '.quick_add_product_main_media.swiper';
  }

  connectedCallback() {
    super.connectedCallback();
    this.syncSlideFocus();
  }

  onSwiperReady() {
    this.swiper.on("slideChange", () => this.syncSlideFocus());
    this.swiper.on("transitionEnd", () => this.syncSlideFocus());
    this.syncSlideFocus();
  }

  syncSlideFocus() {
    const slides = Array.from(
      this.querySelectorAll(".quick_add_product_main_media .swiper-slide"),
    );

    if (slides.length < 2) {
      slides.forEach((slide) => slide.removeAttribute("inert"));
      return;
    }

    const active =
      slides.find((slide) => slide.classList.contains("swiper-slide-active")) ||
      this.swiper?.slides?.[this.swiper.activeIndex] ||
      slides[0];

    slides.forEach((slide) => slide.toggleAttribute("inert", slide !== active));
  }
}

customElements.define('quick-add-product-media', QuickAddProductMedia); 


// MOBILE MENU DRAWER
class MobileMenuDrawer extends HTMLElement {
  constructor() {
    super();
    this.handleClick = this.handleClick.bind(this);
    this.handleKeydown = this.handleKeydown.bind(this);
    this.focusStack = [];
  }

  connectedCallback() {
    this.addEventListener('click', this.handleClick);
    this.addEventListener('keydown', this.handleKeydown);

    // Hide all next pages initially
    this.querySelectorAll('.mobile_menu_next_page').forEach((page) => {
      page.setAttribute('aria-hidden', 'true');
      page.setAttribute('inert', '');
    });

    // Hide all grandchild menus initially
    this.querySelectorAll('.mobile_grandchild_ul').forEach((menu) => {
      menu.setAttribute('aria-hidden', 'true');
      menu.setAttribute('inert', '');
    });
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.handleClick);
    this.removeEventListener('keydown', this.handleKeydown);
  }

  getFocusable(container) {
    return [...container.querySelectorAll(
      'button:not([disabled]), a[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
    )].filter((el) => {
      return (
        !el.closest('[inert]') &&
        el.offsetParent !== null && // visible in layout
        getComputedStyle(el).visibility !== 'hidden'
      );
    });
  }

  // -------------------------
  // Focus trap inside opened page
  // -------------------------
  handleKeydown(e) {
    if (e.key !== 'Tab') return;

    const openPage = this.querySelector('.mobile_menu_next_page[open]');

    let focusable = [];

    if (openPage) {
      // Trap ONLY inside opened next page
      focusable = this.getFocusable(openPage);
    } else {
      // Root level trap
      focusable = [
        ...this.querySelectorAll('.drawer_close_btn'),
        ...this.getFocusable(this.querySelector('.mobile_menu_drawer_content_wrapper')),
        ...this.getFocusable(this.querySelector('.mobile_menu_drawer_utitlities_wrapper'))
      ];
    }

    if (!focusable.length) return;

    const currentIndex = focusable.indexOf(document.activeElement);

    // If somehow focus is outside known list, pull it back safely
    if (currentIndex === -1) {
      e.preventDefault();
      focusable[0].focus({ preventScroll: true });
      return;
    }

    // SHIFT + TAB
    if (e.shiftKey) {
      if (currentIndex === 0) {
        e.preventDefault();
        focusable[focusable.length - 1].focus({ preventScroll: true });
      }
      return;
    }

    // TAB forward
    if (currentIndex === focusable.length - 1) {
      e.preventDefault();
      focusable[0].focus({ preventScroll: true });
    }
  }

  resetMenuState() {
    // Close all sliding next pages
    this.querySelectorAll('.mobile_menu_next_page').forEach((page) => {
      page.removeAttribute('open');
      page.setAttribute('aria-hidden', 'true');
      page.setAttribute('inert', '');
    });

    // Close all grandchild accordions
    this.querySelectorAll('.mobile_grandchild_ul').forEach((submenu) => {
      submenu.removeAttribute('open');
      submenu.setAttribute('aria-hidden', 'true');
      submenu.setAttribute('inert', '');
      submenu.style.height = '';
    });

    // Reset all child toggle buttons
    this.querySelectorAll('.mobile_child_li > button').forEach((btn) => {
      btn.setAttribute('aria-expanded', 'false');
    });

    // Clear stored focus history
    this.focusStack = [];
  }

  handleClick(e) {
    const closeBtn = e.target.closest('.drawer_close_btn');
    if (closeBtn) {
      this.resetMenuState();
      return;
    }

    // -------------------------
    // Back button
    // -------------------------
    const backBtn = e.target.closest('.mobile_menu_back_btn button');
    if (backBtn) {
      const currentPage = backBtn.closest('.mobile_menu_next_page');
      if (!currentPage) return;

      currentPage.removeAttribute('open');
      currentPage.setAttribute('aria-hidden', 'true');
      currentPage.setAttribute('inert', '');

      const prev = this.focusStack.pop();
      prev?.focus({ preventScroll: true });

      return;
    }

    // -------------------------
    // Parent → next page
    // -------------------------
    const parentBtn = e.target.closest('.mobile_parent_li > button');
    if (parentBtn) {
      const title = parentBtn.dataset.title;
      if (!title) return;

      const nextPage = this.querySelector(
        `.mobile_menu_next_page[data-title="${CSS.escape(title)}"]`
      );

      if (!nextPage) return;

      this.focusStack.push(parentBtn);

      nextPage.setAttribute('open', '');
      nextPage.setAttribute('aria-hidden', 'false');
      nextPage.removeAttribute('inert');

      const focusable = this.getFocusable(nextPage);
      focusable[0]?.focus({ preventScroll: true });

      return;
    }

    // -------------------------
    // Child → grandchild toggle
    // -------------------------
    const childBtn = e.target.closest('.mobile_child_li > button');
    if (childBtn) {
      const childLi = childBtn.closest('.mobile_child_li');
      const submenu = childLi?.querySelector(':scope > .mobile_grandchild_ul');

      if (!submenu) return;

      const isOpen = submenu.hasAttribute('open');

      // CLOSE
      if (isOpen) {
        submenu.style.height = `${submenu.scrollHeight}px`;

        requestAnimationFrame(() => {
          submenu.style.height = '0px';
        });

        submenu.addEventListener(
          'transitionend',
          () => {
            submenu.removeAttribute('open');
            submenu.setAttribute('aria-hidden', 'true');
            submenu.setAttribute('inert', '');
            submenu.style.height = '';
          },
          { once: true }
        );

        childBtn.setAttribute('aria-expanded', 'false');
        childBtn.focus({ preventScroll: true });
        return;
      }

      // OPEN
      submenu.setAttribute('open', '');
      submenu.setAttribute('aria-hidden', 'false');
      submenu.removeAttribute('inert');
      submenu.style.height = '0px';

      requestAnimationFrame(() => {
        submenu.style.height = `${submenu.scrollHeight}px`;
      });

      submenu.addEventListener(
        'transitionend',
        () => {
          submenu.style.height = 'auto';

          const firstLink = submenu.querySelector('a, button');
          firstLink?.focus({ preventScroll: true });
        },
        { once: true }
      );

      childBtn.setAttribute('aria-expanded', 'true');
    }
  }
}

customElements.define('mobile-menu-drawer', MobileMenuDrawer);




// PRODUCT RECOMMENDATIONS
class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
    this.productId = this.dataset.productId;
    this.sectionId = this.dataset.sectionId;
    this.recommendedURL = this.dataset.url;
    this.type = this.dataset.type || "related";

    this.observer = new IntersectionObserver(this.handleObserver, {
      rootMargin: "0px 0px 1000px 0px", // load 1000px before visible
      threshold: 0.01,
    });
  }

  connectedCallback() {
    this.observer.observe(this);
  }

  disconnectedCallback() {
    this.observer.disconnect();
  }

  handleObserver = (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        this.observer.disconnect();

        requestAnimationFrame(() => {
          this.loadRecommendedProducts(
            this.recommendedURL,
            this.productId,
            this.sectionId
          );
        });
      }
    });
  };

  loadRecommendedProducts(recommendedURL, productId, sectionId) {
    fetch(`${recommendedURL}&product_id=${productId}&section_id=${sectionId}`)
      .then((response) => response.text())
      .then((data) => {
        const html = document.createElement("div");
        html.innerHTML = data;

        const recommendedProducts = html.querySelector(
          "product-recommendations"
        );

        if (recommendedProducts?.innerHTML.trim().length) {
          this.innerHTML = recommendedProducts.innerHTML;

          this.productsInner =
            this.querySelector(".product_recommendations_inner") ||
            this.querySelector(".complementary_products_inner");

          document.dispatchEvent(
            new CustomEvent("product-recommendations-updated")
          );
        }
      });
  }
}

customElements.define("product-recommendations", ProductRecommendations);


// GIFT CARD RECIPIENT FORM
if (!customElements.get("giftcard-recipient-form")) {
  customElements.define(
    "giftcard-recipient-form",
    class GiftcardRecipientForm extends HTMLElement {
      constructor() {
        super();
        this.checkbox = this.querySelector(
          `#Recipient_checkbox--${this.dataset.sectionId}`,
        );
        this.checkbox.disabled = false;
        this.hiddenControls = this.querySelector(
          `#Recipient_control--${this.dataset.sectionId}`,
        );
        this.wrapper = this.querySelector(".giftcard_recipients_input_wrapper");
        this.inner = this.wrapper.querySelector(".giftcard_recipients_input_inner");
        this.hiddenControls.disabled = true;

        this.emailInput = this.querySelector(
          `#Recipient_email--${this.dataset.sectionId}`,
        );
        this.nameInput = this.querySelector(
          `#Recipient_name--${this.dataset.sectionId}`,
        );
        this.messageInput = this.querySelector(
          `#Recipient_message--${this.dataset.sectionId}`,
        );
        this.sendonInput = this.querySelector(
          `#Recipient_send_on--${this.dataset.sectionId}`,
        );
        this.offsetProperty = this.querySelector(
          `#Recipient_timezone_offset--${this.dataset.sectionId}`,
        );
        if (this.offsetProperty)
          this.offsetProperty.value = new Date().getTimezoneOffset().toString();

        this.currentProductVariantId = this.dataset.variantId;
        this.addEventListener("change", this.onChange.bind(this));
        this.addEventListener("keydown", this.onKeydown.bind(this));
      }

      onKeydown(event) {
        if (event.key !== "Enter") return;
        if (event.target !== this.checkbox) return;

        event.preventDefault();

        this.checkbox.checked = !this.checkbox.checked;
        this.checkbox.dispatchEvent(new Event("change", { bubbles: true }));
      }

      connectedCallback() {
        this.measure();
        this.setExpanded(this.checkbox.checked);

        if ("ResizeObserver" in window) {
          this.resizeObserver = new ResizeObserver(() => this.measure());
          this.resizeObserver.observe(this.inner);
        }
      }

      disconnectedCallback() {
        this.resizeObserver?.disconnect();
      }

      measure() {
        const height = this.inner.scrollHeight;
        if (height) this.wrapper.style.setProperty("--height", `${height}px`);
      }

      setExpanded(expanded) {
        this.wrapper.toggleAttribute("open", expanded);
        this.wrapper.toggleAttribute("inert", !expanded);
        this.checkbox.setAttribute("aria-expanded", expanded ? "true" : "false");
      }

      onChange() {
        this.measure();
        this.setExpanded(this.checkbox.checked);
      }
    },
  );
}


// INFINITE SCROLL
class InfiniteScroll extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector("button");
    this.sectionId = this.dataset.sectionId;

    this.isLoading = false;
  }

  connectedCallback() {
    if (!this.button) return;

    this.button.addEventListener("click", () => {
      this.loadProducts();
    });
  }

  loadProducts() {
    const nextUrl = this.button.dataset.nextUrl;
    if (!nextUrl) return;

    if (this.isLoading) return;

    this.isLoading = true;
    this.showLoader();

    const url = new URL(nextUrl, window.location.origin);
    url.searchParams.set("sections", this.sectionId);

    this.updatePage(url, this.sectionId);
  }

  updatePage(url, id) {    
    fetch(url.toString())
      .then((res) => res.json())
      .then((htmlString) => {
        const temp = document.createElement("div");
        temp.innerHTML = htmlString[id];

        const newWrapper = temp.querySelector(".main_collection_product_grid");
        const oldWrapper = document.querySelector(".main_collection_product_grid");

        if (oldWrapper && newWrapper) {
          const newItems = newWrapper.querySelectorAll(
            ".main_product_card_wrapper",
          );

          if (!newItems.length) {
            this.button.remove();
            return;
          }

          newItems.forEach((item) => {
            item.dataset.revealed = "false";
            oldWrapper.appendChild(item);
          });

          if (window.scrollReveal) {
            const revealItems = Array.from(newItems)
              .map((item) => item.querySelector(".reveal.stagger"))
              .filter(Boolean);

            scrollReveal.staggerBatch(revealItems);
          }          

          const newButton = temp.querySelector("infinite-scroll button");
          if (newButton && newButton?.dataset.nextUrl) {
            this.button.dataset.nextUrl = newButton.dataset.nextUrl;
          } else {
            this.button.remove();
          }
        }

        document.dispatchEvent(
          new CustomEvent("collection-grid-update", {
            detail: {
              url: url,
              sectionId: this.sectionId,
            },
          }),
        );
      })
      .catch((err) => {
        console.error("Error: ", err);
      })
      .finally(() => {
        this.hideLoader();
        this.isLoading = false;
      });
  }

  showLoader() {
    const text = this.button.querySelector(".load_more_text");
    const loader = this.button.querySelector(".pagination_loader");

    if (!text && !loader) return;

    text.classList.add("hidden");
    loader.classList.remove("hidden");
  }

  hideLoader() {
    const text = this.button.querySelector(".load_more_text");
    const loader = this.button.querySelector(".pagination_loader");

    if (!text && !loader) return;

    text.classList.remove("hidden");
    loader.classList.add("hidden");
  }  
}

customElements.define("infinite-scroll", InfiniteScroll);



// PRODUCT CARD SWATCHES
function previewSwatch(swatch) {
  if (swatch.classList.contains('disabled')) return;

  const card = swatch.closest('.product_card_wrapper');
  if (!card) return;

  card.querySelectorAll('.pc_swatch, .pc_swatch_label').forEach((s) => s.classList.remove('pc_swatch--active'));
  swatch.classList.add('pc_swatch--active');


  if (swatch.dataset.variantUrl) {
    card.querySelectorAll('.pc_card_link, .pc_title_link').forEach((link) => {
      link.href = swatch.dataset.variantUrl;
    });
  }


  if (!swatch.dataset.image) return;

  const img = card.querySelector('.main_pc_image');
  if (!img) return;

  if (!img.dataset.pcOriginalSrc) {
    img.dataset.pcOriginalSrc = img.currentSrc || img.src;
  }

  clearTimeout(img._pcSwapTimer);
  img.style.opacity = '0';

  img._pcSwapTimer = setTimeout(() => {
    img.src = swatch.dataset.image;
    img.srcset = '';
    img.style.opacity = '1';
  }, 250);
}

document.addEventListener('keydown', (e) => {
  if (e.key !== ' ') return;
  const swatch = e.target.closest('.pc_swatch, .pc_swatch_label');
  if (!swatch || swatch.classList.contains('disabled')) return;
  e.preventDefault();
  swatch.click();
});

document.addEventListener('click', (e) => {
  const swatch = e.target.closest('.pc_swatch, .pc_swatch_label');
  if (!swatch) return;
  previewSwatch(swatch);
});

document.addEventListener('mouseover', (e) => {
  const swatch = e.target.closest('.pc_swatch, .pc_swatch_label');
  if (!swatch) return;
  previewSwatch(swatch);
});

document.addEventListener('focusin', (e) => {
  const swatch = e.target.closest('.pc_swatch, .pc_swatch_label');
  if (!swatch) return;
  previewSwatch(swatch);
});






/* ======================================================================
   FAQ ACCORDION Section 
   ====================================================================== */

class FAQSection extends HTMLElement {
  constructor() {
    super();
    this.currentOpenItem = null;
    this.resizeObserver = new ResizeObserver(() => this.updateOpenItemHeight());
    this.resizeHandler = () => this.updateOpenItemHeight();
  }

  connectedCallback() {
    const faqItems = this.querySelectorAll('.faq_item');
    const questions = this.querySelectorAll('.faq_question');

   
    faqItems.forEach((item) => {
      const answer = item.querySelector('.faq_answer');
      if (answer) {
        answer.setAttribute('inert', '');
      }
    });

    questions.forEach((question, index) => {
      question.addEventListener('click', (e) => {
        e.preventDefault();
        this.toggleItem(question, faqItems[index]);
      });
    });

   
    window.addEventListener('resize', this.resizeHandler);
  }

  disconnectedCallback() {
   
    window.removeEventListener('resize', this.resizeHandler);
    this.resizeObserver.disconnect();
  }

  updateOpenItemHeight() {
    if (this.currentOpenItem) {
      const answer = this.currentOpenItem.querySelector('.faq_answer');
      const innerContent = answer.querySelector('.faq_answer_inner');
      if (innerContent) {
        answer.style.height = innerContent.offsetHeight + 'px';
      }
    }
  }

  toggleItem(question, item) {
    const answer = item.querySelector('.faq_answer');
    const isCurrentlyOpen = question.classList.contains('active');

    // Close all items
    if (this.currentOpenItem && this.currentOpenItem !== item) {
      const currentQuestion = this.currentOpenItem.querySelector('.faq_question');
      const currentAnswer = this.currentOpenItem.querySelector('.faq_answer');
      
      currentQuestion.classList.remove('active');
      currentQuestion.setAttribute('aria-expanded', 'false');
      currentAnswer.style.height = '0px';
      currentAnswer.setAttribute('inert', ''); 
    }

    // Toggle current item
    if (!isCurrentlyOpen) {
      question.classList.add('active');
      question.setAttribute('aria-expanded', 'true');
      const contentHeight = answer.querySelector('.faq_answer_inner').offsetHeight;
      answer.style.height = contentHeight + 'px';
      answer.removeAttribute('inert'); 
      this.currentOpenItem = item;
      const innerContent = answer.querySelector('.faq_answer_inner');
      if (innerContent) {
        this.resizeObserver.observe(innerContent);
      }
    } else {
      question.classList.remove('active');
      question.setAttribute('aria-expanded', 'false');
      answer.style.height = '0px';
      answer.setAttribute('inert', '');
      this.currentOpenItem = null;
      this.resizeObserver.disconnect();
    }
  }
}

customElements.define('faq-section', FAQSection);


/* ======================================================================
   FAQ ACCORDION Section End
   ====================================================================== */